/**
 * Custom classing similar to what is in theme.js and uses classes/features
 * from the file.
 */
(function () {
  class CustomizationDrawer {
    constructor() {
      this.selectors = {
        drawer: '#CustomizationDrawer',
        form: '#CustomizationDrawerForm',
      };

      this.form = $(this.selectors.form);
      this.drawer = new theme.Drawers('CustomizationDrawer', 'customization');
    }

    open() {
      this.drawer.open();
    }

    close() {
      this.drawer.close();
    }
  }

  // class FinalSaleManager {
  //   _embellisher = undefined

  //   constructor(embellisher) {
  //     this._embellisher = embellisher
  //   }

  //   register() {
  //     this.finalSaleCheckbox = document.querySelector('.bny-final-sale-checkbox')
  //     this.finalSaleCheckbox.addEventListener('change', this._onCheckboxChange.bind(this))

  //     document.addEventListener('drawerPreOpen.CustomizationDrawer', this._onDrawerPreOpen.bind(this))
  //     document.addEventListener('drawerPreClose.CustomizationDrawer', this._onDrawerPreClose.bind(this))
  //   }

  //   _submitBtns() {
  //     return document.querySelectorAll('.personalize-add-to-cart')
  //   }

  //   _onDrawerPreOpen() {
  //     this.finalSaleCheckbox.checked = false
  //     this._submitBtns().forEach(btn => btn.disabled = true)
  //   }

  //   _onDrawerPreClose() {
  //     if (!this.finalSaleCheckbox.checked) {
  //       this._embellisher.reset()
  //     }
  //   }

  //   _onCheckboxChange(ev) {
  //     const submitBtns = this._submitBtns()

  //     if (ev.target.checked) {
  //       submitBtns.forEach(btn => {
  //         if (btn.dataset.stock !== 'OutOfStock') {
  //           btn.disabled = false
  //         }
  //       })
  //     } else {
  //       submitBtns.forEach(btn => btn.disabled = true)
  //     }
  //   }
  // }

  class SessionCache {
    _prefix = 'embellisher.'


    put(namespace, key, value) {
      // Try and make sure it's our own stuff
      namespace = this._prefix + namespace

      let rawItem = window.sessionStorage.getItem(namespace)
      let parsedItem = {}

      // Our rawItem is valid, so we should be able to parse it!
      if (rawItem !== null) {
        parsedItem = JSON.parse(rawItem)
      }

      parsedItem[key] = value
      rawItem = JSON.stringify(parsedItem)
      window.sessionStorage.setItem(namespace, rawItem)
    }

    get(namespace, key) {
      // Try and make sure it's our own stuff
      namespace = this._prefix + namespace

      let rawItem = window.sessionStorage.getItem(namespace)
      let parsedItem = {}

      if (rawItem === null || rawItem === '') {
        return null
      }

      parsedItem = JSON.parse(rawItem)

      if (typeof parsedItem[key] === 'undefined') {
        return null
      }

      return parsedItem[key]
    }
  }

  class Embellisher {
    static Config = {}
    static ActiveVariant = {}
    static VariantOptionMap = {}
    static ProductHandle = ''

    _rendered = false

    _form = undefined

    _customEle = undefined

    _previewEle = undefined

    _drawer = undefined

    _drawerEle = undefined

    _fontOpen = false

    _sessionCache = undefined

    _indestructableElements = [
      'bny-coordinate'
    ]

    constructor(drawer, drawerEle, previewId, customId) {
      this._drawer = drawer
      this._drawerEle = drawerEle
      this._previewId = previewId
      this._customId = customId
      this._sessionCache = new SessionCache()
    }

    init() {
      this._form = document.querySelector('.product-single__form')
      Embellisher.ProductHandle = this._form.dataset.productHandle
      this._registerFormSubmitEv()
      this._registerVariantChangeEv()
      this._generateVariantOptionMap()

      // Let's retrieve the current variant JSON and load it
      const variantJsonEle = document.querySelector('textarea[data-variant-json]')
      if ( ! variantJsonEle) {
        console.error('Could not find current valid Variant JSON')
        return;
      }

      const allVariantsJson = JSON.parse(variantJsonEle.value)

      // console.log('allVariantsJson', allVariantsJson)
      // console.log('variantSKU', variantJsonEle.dataset.currentVariantSku)
      // console.log('variantID', variantJsonEle.dataset.currentVariantId)
      const variant = allVariantsJson.find(v => v.id === parseInt(variantJsonEle.dataset.currentVariantId))

      Embellisher.ActiveVariant = variant
    }

    /**
     * Generates a map of "option1" to the Variant's "name" like "Metal" or "Birthstone Count"
     */
    _generateVariantOptionMap() {
      const fieldsets = document.querySelectorAll('fieldset.variant-input-wrap')

      if ( ! fieldsets || fieldsets.length === 0) {
        console.error('ERROR: Could not find variant input wrap fieldsets')
        return
      }

      const variantMap = {}

      fieldsets.forEach(fieldset => {
        variantMap[ fieldset.dataset.index ] = fieldset.name
      })

      Embellisher.VariantOptionMap = variantMap
    }

    _registerVariantChangeEv() {
      const variantColorMap = {
        'bp-metal-silver': ['steel', 'silver'],
        'bp-metal-gold': ['gold'],
        'bp-metal-rose-gold': ['rose gold'],
        'bp-tortoise': ['tortoise'],
        'bp-blonde-marble': ['blonde marble'],
        'bp-black-marble': ['black marble'],
        'bp-white-marble': ['white marble'],
      };

      document.addEventListener('variant:change', (evt) => {
        // Globally handle the new variant for Embellisher
        Embellisher.ActiveVariant = evt.detail.variant;
        const previewers = document.querySelectorAll('.bny-previewer-contents');

        // Handle the previewer coding
        const variantNameLower = evt.detail.value.toLowerCase();

        previewers.forEach((ele) => {
          Object.keys(variantColorMap).forEach((className) => {
            const variantNames = variantColorMap[className];

            if (variantNames.includes(variantNameLower)) {
              ele.classList.add(className);
            } else {
              ele.classList.remove(className);
            }
          });
        });
      });
    }

    _registerFormSubmitEv() {
      this._form.addEventListener('submit', (ev) => {
        ev.preventDefault()

        // Skip dealing with validation if we haven't touched customizations
        if ( ! this._rendered) {
          this._form.dispatchEvent(new CustomEvent('EmbellisherSubmit', ev))
          return
        }

        // We need to now do validation!
        let canSubmit = true

        this._customEle.childNodes.forEach(node => {
          node.dispatchEvent(new CustomEvent('EmbellisherPreSubmit'))

          // Skip dealing with the collectors
          if (node.nodeName === 'BNY-COLLECTOR') {
            return
          }

          // console.log('verifying customEle', node.nodeName,
          //   'required', node.required, 'required 2', node.getAttribute('required') !== null, 'value', node.value)

          // Skipping disabled/hidden nodes
          if (node.hasAttribute('disabled') || node.hasAttribute('hidden')) {
            return
          }

          if ((node.required && node.value === '') || node.hasError) {
            canSubmit = false
          }
        })

        if (canSubmit) {
          // console.log('allRequiredFulfilled, Launching!', allRequiredFulfilled)
          this._form.dispatchEvent(new CustomEvent('EmbellisherSubmit', ev))
          this._drawer.close()
        }
      })
    }

    async _processSubProduct(productHandle) {
      const data = this._sessionCache.get('subProducts', productHandle)
      if (data) {
        // console.log('[cache hit] sub product', productHandle, 'ld+json', data)
        return true
      }

      const rsp = await fetch(`/products/${ productHandle }?view=itemized`)

      if ( ! rsp.ok) {
        console.error('Failed to retrieve prodHandle', productHandle, 'due to not-ok rsp')
        return false
      }

      const res = await rsp.text()

      const parser = new DOMParser()
      const dom = parser.parseFromString(res, 'text/html')

      const rawJson = dom.getElementById('product-itemized').textContent
      const parsedJson = JSON.parse(rawJson)

      // console.log('[cache miss] sub product', productHandle, 'ld+json & variants', parsedJson)

      this._sessionCache.put('subProducts', productHandle, parsedJson)

      return true
    }

    _parseValue(value, num, next, maxLoops) {
      // console.log("~378 value check pre value type string shenanigans, value)
      // Check if value is a string before calling replace cuz otherwise javascript will pout
      if (typeof value === 'string') {
        // Replace #num with the loop iteration
        value = value.replace(/\$num/g, num);

        /// Replace #is-first with true if i is 1, otherwise blank (so it wont be set)
        value = value.replace(/\$is-first/g, num === 1);

        // Replace #next with the next value if it exists
        // and is valid (not going past the end of loops)
        if (next > maxLoops) {
          value = value.replace(/\$next/g, '');
        } else {
          value = value.replace(/\$next/g, next);
        }
      }

      return value
    }

    _setValueOnElement(ele, key, value, formId) {
      if (key === 'form') {
        ele.setAttribute(key, formId)
        return
      }

      switch (typeof value) {
        case 'string':
          if (value !== '') {
            ele.setAttribute(key, value)
          }

          break
        case 'number':
          ele.setAttribute(key, value)
          break
        case 'boolean':
          if (value) {
            ele.setAttribute(key, '')
          }

          break
        case 'object':
          if (value === null) {
            break
          }

          ele.setAttribute(key, JSON.stringify(value))
          break
      }
    }

    _getIterationsForCustom(custom, config) {
      const foundMapping = config.variant_quantity_map?.variants?.find(v => v.map_id === custom.map_id)
      if ( ! foundMapping) {
        return 1
      }

      // const variantName = variant.element;
      const quantitySelector = foundMapping.quantity_selector;
      //console.log('value check custom', custom)
      //console.log('value check variantName', variantName);
      //console.log('value check custom.attributes.mapping', custom.attributes.mapping);

      let optionKey

      // VariantOptionMap is an object that looks
      // kinda like: {"option1": "Metal", "option2": "Size"}
      // so we want to find an option that matches our query selector
      // and return the option key (option1, option2, etc.)
      // that corresponds to it to use down below for the object
      // Embellisher.ActiveVariant
      Object.keys(Embellisher.VariantOptionMap).forEach(key => {
        const name = Embellisher.VariantOptionMap[key]

        if (name.trim() === quantitySelector.trim()) {
          optionKey = key
        }
      })

      if ( ! optionKey) {
        console.warn('WARN: Embellisher could not find qty selector', quantitySelector,
          'in variant option map', Embellisher.VariantOptionMap)
        return 1
      }

      // console.log('variant', variant, 'selector', selector)
      // console.log('Embellisher.ActiveVariant', Embellisher.ActiveVariant)
      // console.log('Embellisher.VariantOptionMap', Embellisher.VariantOptionMap)

      // We have a valid optionKey, so this should be a number
      const optionValue = parseInt(Embellisher.ActiveVariant[optionKey])

      if (isNaN(optionValue)) {
        console.error('ERROR: Option value', Embellisher.ActiveVariant[optionKey], 'is not a number')
        return 1
      }

      return optionValue
      // console.log(`Selected quantity for "${variantName}" :`, loops);
    }

    async render(config, formId) {
      if (this._rendered) {
        this.reset()

        // console.group('~273 begin async render(config, formId) {')
        // console.log('value check this._indestructableElements ', this._indestructableElements)
        // console.log('value check config.customizations', config.customizations)

        let weCantDestroyElements = false;

        config.customizations.forEach(child => {
          if (child.attributes.class && this._indestructableElements.includes(child.attributes.class.toLowerCase())) {
            // console.log('do not destroy this element', child.attributes.class)
            weCantDestroyElements = true;
          }
        });
        if (weCantDestroyElements) {
          // if we cant destroy the elements, that means they're already there
          // so dont rebuild them.
          // console.groupEnd();
          return
        }
      }

      // console.log('made it through the weCantDestroyElements check without hard fail/return')
      // console.groupEnd();

      this._formId = formId
      this._customEle = document.querySelector(this._customId)
      this._previewEle = document.querySelector(this._previewId)

      if (!this._customEle && !this._previewEle) {
        console.error('!! NO WAY TO RENDER CUSTOMIZATIONS !!')
        return
      }

      if (config.class) {
        this._customEle.classList.add('bc-' + config.class)
      }

      let style
      let fontMgr

      if (! Array.isArray(config.customizations)) {
        console.error('config.customizations is not a valid array!', config)
        return
      }


      if (Array.isArray(config.sub_products)) {
        const promises = [];

        config.sub_products.forEach((productHandle) => {
          promises.push(this._processSubProduct(productHandle))
        })

        await Promise.all(promises)
      }

      Embellisher.Config = config
      // console.group('~326 appending Elements to bny-customizations-drawer')

      config.customizations.forEach(custom => {
        const loops = this._getIterationsForCustom(custom, config)

        for (let num = 1; num <= loops; num++) {
          const next = num + 1

          // Skip this customization if we have a map_only and our index/num is
          // not in the array for map_only
          if (Array.isArray(custom.map_only) && !custom.map_only.includes(num)) {
            // console.log('SKIP DUE TO MAP_ONLY', custom.map_only);
            continue;
          }

          // Create a new element for each iteration
          let ele = document.createElement(custom.element);
          // Pre-Load Font?
          if (custom.element === 'input' && custom.attributes.name.indexOf('Font') >= 0) {
            if (!style) {
              style = document.createElement('style')
              fontMgr = new BNYFontManager()
              style.textContent = ''
            }

            style.textContent += fontMgr.getFontFaceStyle(custom.attributes.value)
          }

          Object.keys(custom.attributes).forEach(key => {
            const value = this._parseValue(custom.attributes[key], num, next, loops)

            this._setValueOnElement(ele, key, value, formId)
          })

          this._customEle.appendChild(ele)
        }
      });

      if (style) {
        document.head.appendChild(style)
      }

      // previewer visibility is driven by whether there's actual content to
      // render. A non-empty `previewer` array in the customization_json is
      // treated as the opt-in; the legacy `previewer: true` block setting is
      // no longer required. if there's nothing to render we hide the wrapper
      // chrome so we don't leave an empty div chewing up the drawer
      const hasInlinePreviewer = Array.isArray(config.previewer) && config.previewer.length > 0

      if (this._previewEle && hasInlinePreviewer) {
        this._previewEle.dataset.enabled = 'true'

        if (config.class) {
          this._previewEle.classList.add('bp-' + config.class)
        }

        this._showPreviewer()
        this._renderPreviewer(config.previewer)
      } else if (this._previewEle) {
        this._previewEle.dataset.enabled = 'false'
        this._hidePreviewer()
      }

      // This is being triggered after all customizations have been added to the page
      // and all previewers have been added to the page. Introduced to handle the
      // situation where we need to populate a default value to the BNYCollector and
      // previewer.
      this._dispatchCustomizationEvent('CustomizationsLoaded')
      this._registerEventHandlers()

      this._rendered = true
    }

    _renderPreviewer(previewer) {
      // guard against blocks where the setting flag is on but the JSON has
      // no previewer array (or it isn't an array)
      if (!Array.isArray(previewer) || previewer.length === 0) {
        return
      }

      previewer.forEach(preview => {
        const ele = document.createElement(preview.element)

        Object.keys(preview.attributes).forEach(key => {
          const value = preview.attributes[key]

          if (key === 'form' && this._formId) {
            ele.setAttribute(key, this._formId)
            return
          }

          switch (typeof value) {
            case 'string':
            case 'number':
              ele.setAttribute(key, value)
              break
            case 'boolean':
              if (value) {
                ele.setAttribute(key, '')
              }

              break
          }
        })

        this._previewEle.appendChild(ele)
      })
    }

    _showPreviewer() {
      const drawer = document.querySelector('.bny-previewer-drawer')
      const header = document.querySelector('.bny-previewer-header')
      if (drawer) { drawer.style.display = '' }
      if (header) { header.dataset.previewer = 'true' }
    }

    _hidePreviewer() {
      const drawer = document.querySelector('.bny-previewer-drawer')
      const header = document.querySelector('.bny-previewer-header')
      if (drawer) { drawer.style.display = 'none' }
      if (header) { header.dataset.previewer = 'false' }
    }

    _dispatchCustomizationEvent(eventName, detail) {
      const ev = new CustomEvent(eventName, {
        detail: detail
      })

      this._customEle.childNodes.forEach(node => {
        node.dispatchEvent(ev)
      })

      if (this._previewEle && this._previewEle.childNodes) {
        this._previewEle.childNodes.forEach(node => {
          node.dispatchEvent(ev)
        })
      }
    }

    _registerEventHandlers() {
      const closeBtns = this._drawerEle.querySelectorAll('.btn-close-font-preview')

      closeBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          this._fontsDrawerCloseEv()
        })
      })

      this._customEle.childNodes.forEach(node => {
        if (node.nodeName !== 'BNY-FONTPICKER') {
          // console.log('skip', node.nodeName)
          return
        }

        node.addEventListener('openFontPreviewModal', (ev) => {
          if (this._fontOpen) {
            return
          }

          const fonts = ev.detail.fonts.toLowerCase().split(',').map(v => v.trim()).filter(v => v !== '')
          let styles = ev.detail.styles.toLowerCase().split(',').map(v => v.trim()).filter(v => v !== '')

          if (styles.length === 0) {
            styles = ['monogram', 'initial']
          }

          const drawerEle = this._drawerEle
          const fontContent = drawerEle.querySelector('.bny-fonts-drawer')

          const sections = fontContent.querySelectorAll('.fpm-section-wrapper')
          const fontImgs = fontContent.querySelectorAll('img')

          fontContent.classList.remove('bfd-closing')
          fontContent.classList.add('bfd-opening')
          fontContent.style.display = ''
          drawerEle.classList.add('js-ignore-outclick')

          this._fontOpen = true

          sections.forEach(section => {
            if (fonts.includes(section.dataset.font)) {
              section.style.display = ''
            } else {
              section.style.display = 'none'
            }
          })

          fontImgs.forEach(img => {
            if (fonts.includes(img.dataset.font) && styles.includes(img.dataset.style)) {
              img.style.display = ''
            } else {
              img.style.display = 'none'
            }
          })
        })
      })

      document.addEventListener('click', (ev) => {
        if ( ! this._fontOpen) {
          return
        }

        if (ev.target.closest('.drawer')) {
          ev.preventDefault()
          return
        }

        ev.preventDefault()
        this._fontsDrawerCloseEv()
      })
    }

    _fontsDrawerCloseEv() {
      const drawer = this._drawerEle.querySelector('.bny-fonts-drawer')

      drawer.classList.remove('bfd-opening')
      drawer.classList.add('bfd-closing')

      this._fontOpen = false

      setTimeout(() => {
        drawer.style.display = 'none'

        if (this._drawerEle.classList.contains('js-ignore-outclick')) {
          this._drawerEle.classList.remove('js-ignore-outclick')
        }
      }, 200)
    }

    reset() {
      const previewEle = document.querySelector(this._previewId)
      const customEle = document.querySelector(this._customId)

      let weCantDestroyElements = false;

      Embellisher.Config.customizations.forEach(child => {
        if (this._indestructableElements.includes(child.element)) {
          weCantDestroyElements = true
        }
      });

      if (weCantDestroyElements) {
        // Send out an event to tell our elements to reset the generated elements
        // to avoid any unnecessary reloading (particularly concerning things like
        // the Coordinate feature which relies on Google Maps)
        this._dispatchCustomizationEvent('CustomizationsReset')
      } else {
        // we want to destroy->rebuild on drawer close->open in case customer changes data
        // eg. birthstone/engraving/initial count
        // console.log('YEET', customEle, previewEle);
        this._rendered = false

        customEle.innerHTML = ''
        previewEle.innerHTML = ''
      }

      // Regardless of element state, we want the fonts drawer to close ~
      this._fontsDrawerCloseEv()
    }
  }

  // Embellisher™: Embellish, but kind-of-better
  window._embellisher = window._embellisher || {}
  window._embellisher.CustomizationDrawer = CustomizationDrawer
  window._embellisher.Embellisher = Embellisher
  // window._embellisher.FinalSaleManager = FinalSaleManager

  // document.addEventListener('variant:change', function (evt) {
  //   var previewers = document.querySelectorAll('.bny-previewer-contents')
  //   activeVariant = evt.detail

  //   // console.log('variant:change', evt);

  //   previewers.forEach(ele => {
  //     ele.classList.remove('bp-metal-rose-gold')
  //     ele.classList.remove('bp-metal-gold')
  //     ele.classList.remove('bp-metal-silver')
  //     ele.classList.remove('bp-tortoise')
  //     ele.classList.remove('bp-blonde-marble')
  //     ele.classList.remove('bp-black-marble')
  //     ele.classList.remove('bp-white-marble')

  //     switch (evt.detail.value.toLowerCase()) {
  //       case 'steel':
  //       case 'silver':
  //         ele.classList.add('bp-metal-silver')
  //         break
  //       case 'gold':
  //         ele.classList.add('bp-metal-gold')
  //         break
  //       case 'rose gold':
  //         ele.classList.add('bp-metal-rose-gold')
  //         break
  //       case 'tortoise':
  //         ele.classList.add('bp-tortoise')
  //         break
  //       case 'blonde marble':
  //         ele.classList.add('bp-blonde-marble')
  //         break
  //       case 'black marble':
  //         ele.classList.add('bp-black-marble')
  //         break
  //       case 'white marble':
  //         ele.classList.add('bp-white-marble')
  //         break
  //     }
  //   })
  // })

  let internalUniqueId = 0

  /**
   *
   * @param {string} parentSku
   * @param {Record<string, Record<string, string>>} mapping
   * @returns {Record<string, string>|null}
   */
  function handleRegexMapping(parentSku, mapping) {
    /**
     * @var Record<string, string>|null
     */
    let parentSkuMap = null

    Object.keys(mapping).every(key => {
      // Not flagged as regexp
      if (key.indexOf('/') !== 0 && key.lastIndexOf('/') !== key.length - 1) {
        return true
      }

      const rgx = new RegExp(key.substring(1, key.length - 1))

      // console.log(key, parentSku, rgx, rgx.test(parentSku))
      if (rgx.test(parentSku)) {
        parentSkuMap = mapping[key]
        return false
      }

      return true
    }) // end of every

    return parentSkuMap
  }

  function urlize(str) {
    str = str.toLowerCase()
    str = str.replace(/[^a-zA-Z0-9]+/g, '-')
    str = str.replace(/-{2,}/g, '-')

    return str
  }

  function fetchRemoteScript(src, attachTo) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script')

      script.src = src
      script.addEventListener('onload', () => resolve())
      script.addEventListener('abort', () => reject('abort'))
      script.addEventListener('error', () => reject('error'))

      attachTo = attachTo || document.body
      attachTo.appendChild(script)
    })
  }

  /**
   *
   * @param {luxon.DateTime|null} time
   * @param {'input'|'cart'|'roman'} style
   * @returns {string}
   */
  function formatDate(time, style = 'input') {
    time = time || luxon.DateTime.now()

    let format = ''

    switch (style) {
      case 'cart':
        format = 'M.d.yyyy'
        break
      case 'roman':
        const working_date = time.toFormat('yyyy-M-dd');
        const date_array = working_date.split("-");
        const roman_display_array = [];
        date_array.forEach((element) => {
          var digits = String(+element).split('');
          var key = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM',
            '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC',
            '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
          var roman = '', i = 3;
          while (i--) roman = (key[+digits.pop() + (i * 10)] || '') + roman;
          element = Array(+digits.join('') + 1).join('M') + roman;
          roman_display_array.push(element);
        });
        const roman_display = roman_display_array[1] + '.' + roman_display_array[2] + '.' + roman_display_array[0];
        return roman_display;
      case 'input':
      default:
        format = 'yyyy-MM-dd'
        break
    }

    return time.toFormat(format);
  }

  class BNYFontManager {

    constructor() {
      this._script = document.getElementById('customization-js')
      this._baseUrl = this._script.src.replace(/customizations\.js.+$/, '')
    }

    getFontFaceStyle(fontName) {
      fontName = fontName.toLowerCase()
      // console.log('getFontFaceStyle', fontName)

      switch (fontName) {
        case 'script':
          return this.fontScript()
        case 'modern':
          return this.fontModern()
        case 'classic':
          return this.fontClassic()
        case 'nellasue':
          return this.fontNellaSue()
        case 'monogram':
          return this.fontMonogram()
        case 'garamond':
          return this.fontGaramond()
        case 'didot':
          return this.fontDidot()
        case 'great vibes':
        case 'greatvibes':
          return this.fontGreatVibes()
        case 'merriweather':
          return this.fontMerriweather()
        default:
          return ''
      }
    }

    _genFontFace(config) {
      if (Object.keys(config).length === 0) {
        return ''
      }

      const srcList = []
      const order = ['woff2', 'woff', 'ttf', 'svg']

      order.forEach(formatName => {
        if (config[formatName]) {
          srcList.push("url('" + config[formatName] + "') format('" + (formatName === 'ttf' ? 'truetype' : formatName) + "')")
        }
      })

      return "@font-face {\n" +
        "font-family: '" + config.family + "';\n" +
        "src: " + srcList.join(', ') + ";\n" +
        "font-weight: normal;\n" +
        "font-style: normal;\n" +
        "font-display: swap;\n" +
      "}\n"
    }

    _generateConfig(familyName, baseFileName, formats) {
      // console.log('_generateConfig', familyName, baseFileName)

      const config = {
        family: familyName,
      }

      formats.forEach(format => {
        config[format] = this._genAssetUrl(baseFileName, format)
      })

      return config
    }

    _genAssetUrl(baseFileName, format) {
      // console.log('_genAssetUrl', this._baseUrl, baseFileName, format)
      return this._baseUrl + baseFileName + '.' + format
    }

    fontScript() {
      const cfg1 = this._generateConfig('ShelleyLT-AllegroScript', '320399_0_0', ['woff2', 'woff', 'ttf'])
      const cfg2 = this._generateConfig('EngraveScript', 'engravescript-webfont', ['woff', 'ttf', 'svg'])

      return this._genFontFace(cfg1) + this._genFontFace(cfg2)
    }

    fontModern() {
      const cfg = this._generateConfig('HelveticaNeueLTStd-Th', '32048B_0_0', ['woff2', 'woff', 'ttf'])

      return this._genFontFace(cfg)
    }

    fontClassic() {
      const cfg = this._generateConfig('bluefish_demoregular', 'bluefish_regular_demo-webfont', ['woff2', 'woff', 'ttf'])

      return this._genFontFace(cfg)
    }

    fontNellaSue() {
      const cfg = this._generateConfig('nellasue_regular', 'nellasue-webfont', ['woff2', 'woff', 'ttf'])

      return this._genFontFace(cfg)
    }

    fontMonogram() {
      const cfg = this._generateConfig('Monogram-Script', 'ScriptMonogram2', ['woff2'])

      return this._genFontFace(cfg)
    }

    fontGaramond() {
      const cfg = this._generateConfig('Garamond', 'EBGaramond', ['ttf'])

      return this._genFontFace(cfg)
    }

    fontDidot() {
      const cfg = this._generateConfig('Didot', 'GFSDidot-Regular', ['ttf'])

      return this._genFontFace(cfg)
    }

    fontGreatVibes() {
      const cfg = this._generateConfig('Great Vibes', 'GreatVibes-Regular', ['ttf'])

      return this._genFontFace(cfg)
    }

    fontMerriweather() {
      const cfg = this._generateConfig('Merriweather', 'Merriweather', ['ttf']);

      return this._genFontFace(cfg)
    }
  }

  class BNYGoogleMaps {
    static MapsLoaded = false

    static init(attachTo) {
      if (BNYGoogleMaps.MapsLoaded) {
        return
      }

      const mapsUrl = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCHKzUV1XdybI7Z5yroSroKwojAqX3zrmE&v=3.22&signed_in=true&libraries=places&callback=bnyGoogleMapsReady'

      return new Promise((resolve, reject) => {
        window.bnyGoogleMapsReady = () => resolve()

        fetchRemoteScript(mapsUrl, attachTo)
          .catch(err => reject(err))
      })
    }
  }

  class BNYMonogramTabs extends HTMLElement {
    _shadow = undefined

    type = ''
    value = ''

    constructor() {
      super()

      this._shadow = this.attachShadow({ mode: 'open' })
    }

    static get observedAttributes() {
      return []
    }

    attributeChangedCallback(attr, oldVal, newVal) {

    }

    connectedCallback() {
      this.required = (this.getAttribute('required') !== null)
      // Type is what "tab" this is set to, defaulting to Monogram
      this.type = 'Monogram'
      // Value is what the value of the tab contents is. So, for monogram
      // this should be the complete monogram value from all three inputs
      this.value = ''

      const shadow = this._shadow

      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = document.getElementById('customization-css').href

      const baseWrapper = document.createElement('div')
      baseWrapper.setAttribute('class', 'bc-element bc-monogram-tabs')

      if (this.required) {
        baseWrapper.classList.add('bc-required')
      }

      const divLabel = document.createElement('div')
      divLabel.setAttribute('class', 'bc-label bc-label-monogram')
      divLabel.textContent = 'Select an Engraving Style'

      baseWrapper.appendChild(divLabel)

      const choiceWrapper = document.createElement('div')
      choiceWrapper.setAttribute('class', 'bc-elements bc-elements-choices')

      const opts = ['Monogram', 'Single Initial']
      const optInputs = []

      const imageUrlEles = document.querySelectorAll('.bny-customizations-image-url')
      const imageUrls = {}

      if (imageUrlEles.length) {
        imageUrlEles.forEach(ele => {
          imageUrls[ ele.dataset.name ] = ele.dataset.src
        })
      }

      // console.log('imageUrls', imageUrls)
      // console.log('imageUrlEles', imageUrlEles)

      // Build the inputs and clickable elements for each tab (Monogram and Single Initial)
      // If it's the Monogram (idx === 0) then it will be defaulted to checked.
      opts.forEach((optName, idx) => {
        const inputId = 'bc-input-' + internalUniqueId

        const input = document.createElement('input')
        input.setAttribute('class', 'bc-input bc-input-monogram-choice')
        input.type = 'radio'
        input.name = 'engraving_style'
        input.id = inputId
        input.value = optName
        input.checked = (idx === 0)

        optInputs.push(input)

        const label = document.createElement('label')
        label.setAttribute('class', 'bc-label bc-label-monogram-choice')
        label.setAttribute('for', inputId)

        // The span for the image element at the top of the element
        const span1 = document.createElement('span')
        span1.setAttribute('class', 'bc-label-inner bc-label-inner-image')

        const img = document.createElement('img')
        img.src = imageUrls[ optName ] || ''
        img.width = 90
        img.height = 60
        img.loading = 'lazy'

        span1.appendChild(img)

        // The span for the text below the image
        const span2 = document.createElement('span')
        span2.setAttribute('class', 'bc-label-inner bc-label-inner-text')
        span2.textContent = optName

        // Make the label's body the two spans
        label.appendChild(span1)
        label.appendChild(span2)

        // Build the wrapper for the input and label so they're together in a div
        const wrap = document.createElement('div')
        wrap.setAttribute('class', 'bc-element-choice bc-element-monogram-choice')
        wrap.appendChild(input)
        wrap.appendChild(label)

        // Add this tab options wrapper to the choice div
        choiceWrapper.appendChild(wrap)

        internalUniqueId++
      })

      // Add the choice div to the base element
      baseWrapper.appendChild(choiceWrapper)

      // Add the link & base element to the shadow realm
      shadow.appendChild(link)
      shadow.appendChild(baseWrapper)

      // If either of the tabs changed their value, we want to adjust things!
      shadow.addEventListener('change', (ev) => {
        this.type  = ev.target.value

        // Reset the required error if it's present
        if (baseWrapper.classList.contains('bc-required-error')) {
          baseWrapper.classList.remove('bc-required-error')
        }

        // Dispatch the change
        this._dispatchTabChangeEv(ev.target.value)
      })

      // The customization modal opening
      this.addEventListener('CustomizationsLoaded', () => {
        this._dispatchTabChangeEv(this.type)
      })

      // The customization modal resetting (usually closing)
      this.addEventListener('CustomizationsReset', () => {
        this.type = 'Monogram'
        this.value = ''

        optInputs.forEach(input => {
          input.checked = input.value === 'Monogram'
        })

        this._dispatchTabChangeEv('Monogram')
      })

      this.addEventListener('EmbellisherPreSubmit', () => {
        if (this.required && this.value === '') {
          baseWrapper.classList.add('bc-required-error')
        } else {
          baseWrapper.classList.remove('bc-required-error')
        }
      })
    }

    /**
     *
     * @param list
     * @returns {string[]}
     * @private
     */
    _parseList(list) {
      let items = list.split(',')

      items = items.map(item => item.trim())
      items = items.filter(item => item !== '')

      return items
    }

    _collectChildValue(type) {
      // console.log('collectChildValue', type)
      let selectorList = ''

      if (type === 'Monogram') {
        selectorList = this.getAttribute('monogram')
      } else {
        selectorList = this.getAttribute('initial')
      }

      const queries = this._parseList(selectorList)

      let value = '';

      queries.forEach(query => {
        const item = document.querySelector(query);
        value += item.value;
      });

      return value;
    }

    _onChildChangeEv(ev) {
      this.value = this._collectChildValue(this.type)

      // console.log('_onChildChangeEv', this.value)
      this.dispatchEvent(new CustomEvent('change', {
        value: this.value,
      }))
    }

    _dispatchTabChangeEv(type) {
      this.value = this._collectChildValue(type)
      this.dispatchEvent(new CustomEvent('tab-change', {
        type: type,
      }))

      this.dispatchEvent(new CustomEvent('change', {
        value: this.value,
      }))

      // console.log('!! _dispatchChangeEv !!', type)

      const isMonogram = type === 'Monogram'
      const isSingleInitial = ! isMonogram

      const monogramQueries = this._parseList(this.getAttribute('monogram'))

      monogramQueries.forEach(query => {
        const item = document.querySelector(query)
        const previewer = document.getElementById("bny-previewer");

        // It's the monogram, so we want to activate the monogram elements
        if (isMonogram) {
          item.removeAttribute('disabled')
          item.removeAttribute('hidden')

          previewer.classList.forEach(className => {
            if (className.indexOf('bp-engraving') >= 0) {
              previewer.classList.remove(className)
            }
          })
          previewer.classList.add('bp-engraving-monogram')
        } else {
          item.setAttribute('disabled', '')
          item.setAttribute('hidden', '')

          previewer.classList.forEach(className => {
            if (className.indexOf('bp-engraving') >= 0) {
              previewer.classList.remove(className)
            }
          })
          previewer.classList.add('bp-engraving-singleInitial')
        }

        if (isMonogram && item.dataset.registered !== 'true') {
          item.addEventListener('change', this._onChildChangeEv.bind(this))
        } else if (isSingleInitial && item.dataset.registered === 'true') {
          item.removeEventListener('change', this._onChildChangeEv.bind(this))
        }
      })

      const initialQueries = this._parseList(this.getAttribute('initial'))

      initialQueries.forEach(query => {
        const item = document.querySelector(query)

        // It's not the monogram, so we want to activate the initial(s)
        if (isSingleInitial && item.hasAttribute('hidden')) {
          item.removeAttribute('disabled')
          item.removeAttribute('hidden')
        } else if (isMonogram) {
          item.setAttribute('disabled', '')
          item.setAttribute('hidden', '')
        }

        if (isSingleInitial && item.dataset.registered !== 'true') {
          item.addEventListener('change', this._onChildChangeEv.bind(this))
        } else if (isMonogram && item.dataset.registered === 'true') {
          item.removeEventListener('change', this._onChildChangeEv.bind(this))
        }
      })

      const fontQueries = this._parseList(this.getAttribute('font'))

      fontQueries.forEach(query => {
        const item = document.querySelector(query)

        if (isMonogram) {
          item.setAttribute('fonts', this.getAttribute('monogram-fonts'))
        } else {
          item.setAttribute('fonts', this.getAttribute('initial-fonts'))
        }
      })
    }
  }

  /**
   * CoreEngravingTabs — WEB-9150
   *
   * A brand-neutral generalization of *MonogramTabs. Instead of hardcoded
   * Monogram/Single Initial/Text tabs, the tab list is config-driven: each tab
   * maps a display label to a CSS selector for the child customization component
   * it governs (e.g. a coordinate input, a date input, a roman-numeral date input).
   *
   * On tab change it shows the active child, hides+disables the rest (same
   * [hidden]/disabled mechanism *MonogramTabs uses), and exposes the active
   * child's `.value` as its own `.value`, firing `change` so a single
   * core-collector / core-itemized-collector pointed at this element picks up
   * whichever engraving type the shopper selected.
   *
   * Config example (attributes.tabs is a JSON string):
   *  {
   *    "element": "core-engraving-tabs",
   *    "attributes": {
   *        "id": "engraving-tabs",
   *        "label": "Choose Your Engraving",
   *        "required": true,
   *        "tabs": [{"label":"Coordinate","target":"#engrave-coord"},{"label":"Date","target":"#engrave-date"},{"label":"Roman Numeral","target":"#engrave-roman"}]
   *    }
   *  }
   */
  class CoreEngravingTabs extends HTMLElement {
    _shadow = undefined

    _tabs = []           // [{ label, target }]
    _inputs = []         // radio inputs, index-aligned to _tabs
    _activeTarget = ''   // selector of the currently-active child component
    _group = ''          // radio-group name (unique per instance)

    type = ''            // active tab label (mirrors *MonogramTabs.type)
    value = ''           // active child's value

    constructor() {
      super()
      this._shadow = this.attachShadow({ mode: 'open' })
    }

    static get observedAttributes() {
      return []
    }

    attributeChangedCallback(attr, oldVal, newVal) {}

    _parseTabs() {
      const raw = this.getAttribute('tabs')

      if (!raw) {
        console.error('CoreEngravingTabs: missing "tabs" attribute')
        return []
      }

      try {
        const parsed = JSON.parse(raw)

        if (!Array.isArray(parsed)) {
          throw new Error('tabs is not an array')
        }

        return parsed.filter(t => t && t.label && t.target)
      } catch (err) {
        console.error('CoreEngravingTabs: invalid "tabs" JSON', raw, err)
        return []
      }
    }

    // Show the active child, hide + disable the rest.
    _showActive() {
      this._tabs.forEach(tab => {
        const eles = document.querySelectorAll(tab.target)

        if (!eles || eles.length === 0) {
          console.warn('Tab target did not generate valid list', eles)
          return
        }

        if (tab.target === this._activeTarget) {
          eles.forEach(ele => {
            ele.removeAttribute('hidden')
            ele.removeAttribute('disabled')
          })
        } else {
          eles.forEach(ele => {
            ele.setAttribute('hidden', '')
            ele.setAttribute('disabled', '')
          });
        }
      })
    }

    _collect() {
      const el = document.querySelector(this._activeTarget)
      this.value = (el && typeof el.value !== 'undefined') ? el.value : ''
      return this.value
    }

    // Swap the shared font picker's font set to the active tab's `fonts` list,
    // mirroring *MonogramTabs' per-type `*-fonts` behavior. Requires a `font`
    // attribute (selector for the picker) and a `fonts` key on the tab entry.
    _applyFonts(tab) {
      const fontSel = this.getAttribute('font')
      if (!fontSel) { return }

      const picker = document.querySelector(fontSel)
      if (!picker) { return }

      if (tab && tab.fonts) {
        picker.removeAttribute('hidden')
        picker.removeAttribute('disabled')
        picker.setAttribute('fonts', tab.fonts)
        // The font collector only captures values on 'change'; the picker won't emit
        // one when the current selection stays valid across a tab switch, so the
        // default font would never be collected. Nudge it so properties[Font] always
        // reflects the active tab's current font.
        picker.dispatchEvent(new CustomEvent('change', { detail: { value: picker.value } }))
      } else {
        // Tab defines no fonts (e.g. a type that isn't engraved in a font) — hide it.
        picker.setAttribute('hidden', '')
        picker.setAttribute('disabled', '')
      }
    }

    _select(target, silent) {
      this._activeTarget = target

      const tab = this._tabs.find(t => t.target === target)
      this.type = tab ? tab.label : ''

      this._inputs.forEach(inp => { inp.checked = inp.value === target })

      this._showActive()
      this._applyFonts(tab)
      this._collect()

      if (!silent) {
        this.dispatchEvent(new CustomEvent('tab-change', { detail: { type: this.type } }))
        this.dispatchEvent(new CustomEvent('change', { detail: { value: this.value } }))
      }
    }

    connectedCallback() {
      this.required = (this.getAttribute('required') !== null)
      this.value = ''
      this._tabs = this._parseTabs()
      this._group = 'engraving-style-' + internalUniqueId
      internalUniqueId++;

      const shadow = this._shadow

      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = document.getElementById('customization-css').href

      const baseWrapper = document.createElement('div')
      baseWrapper.setAttribute('class', 'bc-element bc-monogram-tabs bc-engraving-tabs')

      if (this.required) {
        baseWrapper.classList.add('bc-required')
      }

      const divLabel = document.createElement('div')
      divLabel.setAttribute('class', 'bc-label bc-label-monogram')
      divLabel.textContent = this.getAttribute('label') || 'Select an Engraving Style'
      baseWrapper.appendChild(divLabel)

      const choiceWrapper = document.createElement('div')
      choiceWrapper.setAttribute('class', 'bc-elements bc-elements-choices bc-elements-tab-choices')

      this._tabs.forEach((tab, idx) => {
        const inputId = 'bc-input-' + internalUniqueId
        internalUniqueId++;

        const input = document.createElement('input')
        input.setAttribute('class', 'bc-input bc-input-monogram-choice')
        input.type = 'radio'
        input.name = this._group
        input.id = inputId
        input.value = tab.target
        input.checked = (idx === 0)
        this._inputs.push(input)

        const label = document.createElement('label')
        label.setAttribute('class', 'bc-label bc-label-monogram-choice')
        label.setAttribute('for', inputId)

        const span1 = document.createElement('span')
        span1.setAttribute('class', 'bc-label bc-label-choice bc-label-tab-choice')
        span1.textContent = tab.label
        label.appendChild(span1)

        const wrap = document.createElement('div')
        wrap.setAttribute('class', 'bc-element-choice bc-element-monogram-choice')
        wrap.appendChild(input)
        wrap.appendChild(label)

        choiceWrapper.appendChild(wrap)
      })

      baseWrapper.appendChild(choiceWrapper)

      // Self-contained tab-button styling so this renders as buttons regardless
      // of which customizations.css version a store has deployed (the tab-button
      // classes drift across brand copies). Mirrors the .bc-label-tab-choice look.
      // Self-contained tab-button styling: buttons sit in a single equal-width row
      // (saves mobile height vs. the stacked monogram tabs) using BNY's own border
      // colors — #e1e1ea idle, #9e6463 active (matches customizations.css:417,422).
      const style = document.createElement('style')
      style.textContent = `
        .bc-elements-tab-choices {
          display: flex;
          flex-wrap: nowrap;
          gap: 8px;
          justify-content: flex-start;
          margin-top: 4px;
        }
        .bc-element-monogram-choice { flex: 1 1 0; min-width: 0; padding: 0; margin: 0; }
        .bc-input-monogram-choice { display: none; }
        .bc-label-monogram-choice { display: block; margin: 0; cursor: pointer; }
        .bc-label-tab-choice {
          box-sizing: border-box;
          width: 100%;
          min-height: 44px;
          padding: 6px 10px;
          border: 1px solid #e1e1ea;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          cursor: pointer;
        }
        .bc-input-monogram-choice:checked + .bc-label-monogram-choice .bc-label-tab-choice {
          border-color: #9e6463;
          outline: 1px solid #9e6463;
        }
        @media only screen and (max-width: 768px) {
          .bc-elements-tab-choices { gap: 6px; }
          .bc-label-tab-choice { padding: 6px 4px; font-size: 13px; }
        }
      `

      shadow.appendChild(link)
      shadow.appendChild(style)
      shadow.appendChild(baseWrapper)

      if (this._tabs.length) {
        this._activeTarget = this._tabs[0].target
      }

      // Tab clicked
      shadow.addEventListener('change', (ev) => {
        if (baseWrapper.classList.contains('bc-required-error')) {
          baseWrapper.classList.remove('bc-required-error')
        }
        this._select(ev.target.value, false)
      })

      // Re-collect when the *active* child's own value changes.
      this._onChildChange = (ev) => {
        const activeEl = document.querySelector(this._activeTarget)
        if (activeEl && ev.target === activeEl) {
          this._collect()
          this.dispatchEvent(new CustomEvent('change', { detail: { value: this.value } }))
        }
      }

      // Children are rendered as siblings; wire them once everything exists.
      this.addEventListener('CustomizationsLoaded', () => {
        this._tabs.forEach(tab => {
          const el = document.querySelector(tab.target)
          if (el) { el.addEventListener('change', this._onChildChange) }
        })
        this._select(this._activeTarget, false)
      })

      this.addEventListener('CustomizationsReset', () => {
        if (this._tabs.length) { this._select(this._tabs[0].target, false) }
      })

      this.addEventListener('EmbellisherPreSubmit', () => {
        this._collect()
        if (this.required && this.value === '') {
          baseWrapper.classList.add('bc-required-error')
        } else {
          baseWrapper.classList.remove('bc-required-error')
        }
      })

      // Best-effort initial hide in case children already exist in the DOM.
      this._showActive()
    }
  }

  class BNYCoordinate extends HTMLElement {
    _shadow = undefined

    _mapEle = undefined

    _gmaps = undefined

    _marker = undefined

    _geoCoder = undefined

    _autoComplete = undefined

    _multiLine = false

    static DefaultCoords() {
      return new google.maps.LatLng(41.7932559, -90.9089867)
    }

    constructor() {
      super();

      this._shadow = this.attachShadow({ mode: 'open' })
    }

    static get observedAttributes() {
      return [
        'label',
        'id',
        'class',
        'name',
        'required',
      ]
    }

    attributeChangedCallback(attr, oldVal, newVal) {
      // do nothing i guess
    }

    connectedCallback() {
      this.required = (this.getAttribute('required') !== null)
      this.value = ''

      if (this.getAttribute('multiline') !== null) {
        this._multiLine = true
      }

      const shadow = this._shadow

      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = document.getElementById('customization-css').href

      const wrapper = document.createElement('div')
      wrapper.setAttribute('class', 'bc-element bc-coordinates')

      if (this.required) {
        wrapper.classList.add('bc-required')
      }

      const inputId = 'bc-input-' + internalUniqueId

      const input = document.createElement('input')
      input.type = 'text'
      input.id = inputId
      input.setAttribute('class', 'bc-input bc-input-coordinate')

      this._input = input

      const label = document.createElement('label')
      label.setAttribute('class', 'bc-label bc-label-coordinate')
      label.setAttribute('for', inputId)

      if (this.getAttribute('label') !== null) {
        label.textContent = this.getAttribute('label')
      } else {
        label.textContent = 'Address'
      }

      this._mapEle = document.createElement('div')
      this._mapEle.id = 'bnyCoordinateMap-' + internalUniqueId
      this._mapEle.setAttribute('class', 'bc-block bc-block-coordinate')

      internalUniqueId++

      wrapper.appendChild(label)
      wrapper.appendChild(input)

      shadow.appendChild(link)
      shadow.appendChild(wrapper)
      shadow.appendChild(this._mapEle)

      // We initialize the Google Maps API and, if successful, continue on ~
      BNYGoogleMaps
        .init(this._shadow)
        .then(() => this._setupGoogleMaps())
        .catch(err => this._ohGodGoogleMapsDied(err))

      input.addEventListener('keyup', () => {
        if (wrapper.classList.contains('bc-required-error')) {
          wrapper.classList.remove('bc-required-error')
        }
      })

      this.addEventListener('CustomizationsLoaded', () => {
        this.value = ''

        this.dispatchEvent(new CustomEvent('change', {
          value: ''
        }))
      })

      this.addEventListener('CustomizationsReset', () => {
        this._gmapsChangeToDefaultLocation()

        this.value = ''
        this._input.value = ''

        this.dispatchEvent(new CustomEvent('change', {
          value: ''
        }))
      })

      this.addEventListener('EmbellisherPreSubmit', () => {
        if (this.required && this.value === '') {
          wrapper.classList.add('bc-required-error')
        } else {
          wrapper.classList.remove('bc-required-error')
        }
      })
    }

    _gmapsChangeToDefaultLocation() {
      if (this._marker && this._marker.setMap) {
        this._marker.setMap(null)
      }

      const coords = BNYCoordinate.DefaultCoords()

      this._marker = new google.maps.Marker({
        map: this._gmaps,
        position: coords,
        title: 'Location Found!',
      })

      this._gmaps.setCenter(coords)
      this._gmaps.setZoom(3)
    }

    _gmapsAddressCallback(place, zoomSet) {
      // console.log('addressCallback', place, zoomSet)

      this._marker.setMap(null)

      this._marker = new google.maps.Marker({
        map: this._gmaps,
        position: place.geometry.location,
        title: 'Location Found!',
      })

      this._gmaps.setCenter(place.geometry.location)
      this._gmaps.setZoom(zoomSet)

      this.value = this._formatCoordinates(place.geometry.location)

      this.dispatchEvent(new CustomEvent('change', {
        value: this.value,
      }))
    }

    _formatCoordinates(coords) {
      const lat = coords.lat()
      const lng = coords.lng()

      const makeNum = (num) => Math.abs(Math.round(num * 10000) / 10000) + '° '

      let output = ''

      if (lat > 0) {
        output = makeNum(lat) + 'N'
      } else {
        output = makeNum(lat) + 'S'
      }

      if (this._multiLine) {
        output += '\n'
      } else {
        output += ' '
      }

      if (lng > 0) {
        output += makeNum(lng) + 'E'
      } else {
        output += makeNum(lng) + 'W'
      }

      return output
    }

    _ohGodGoogleMapsDied(err) {
      const style = document.createElement('style')
      style.textContent = `
.bc-error-ohgod {
  font-weight: bold;
  color: red;
}
`

      const div = document.createElement('div')
      div.classList.add('bc-error-ohgod')
      div.textContent = 'Something went horribly wrong: ' + err

      this._shadow.appendChild(div)

      console.error('OHGOD', err)
    }

    _setupGoogleMaps() {
      const coords = BNYCoordinate.DefaultCoords()

      this._gmaps = new google.maps.Map(this._mapEle, {
        center: coords,
        scrollwheel: false,
        zoom: 2,
      })

      this._marker = new google.maps.Marker({
        map: this._gmaps,
        position: coords,
        title: 'Location Found!',
      })

      this._geoCoder = new google.maps.Geocoder()

      this._autoComplete = new google.maps.places.Autocomplete(
        this._input,
        { types: ['geocode'] }
      )

      google.maps.event.addListener(this._autoComplete, 'place_changed', () => {
        const place = this._autoComplete.getPlace()

        if (!place.geometry) {
          this._geoCoder.geocode({ address: place.name }, (results, status) => {
            this._gmapsAddressCallback(results[0], 15)
          })
        } else {
          this._gmapsAddressCallback(place, 15)
        }
      })
    }
  }

  class BNYDropDown extends HTMLElement {
    _shadow = undefined

    _select = undefined

    _disabledValue = ''

    constructor() {
      super();

      this._shadow = this.attachShadow({ mode: 'open' })
    }

    static get observedAttributes() {
      return [
        'id',
        'label',
        'name',
        'disabled',
        'required',
        'alphabet',
        'options',
        'show-blank',
      ]
    }

    attributeChangedCallback(attr, oldVal, newVal) {
      // console.log('BNYDropDown attributeChanged', attr, 'oldVal=', typeof oldVal, oldVal, 'newVal=', typeof newVal, newVal)

      if (oldVal === newVal) {
        return
      }

      switch (attr) {
        case 'required':
          break
        case 'hidden':
        case 'disabled':
          if (typeof newVal === 'string') {
            // Store the current value in a new place, so when we unhide/un-disable
            // we can restore it!
            this._disabledValue = this.value
            this.value = ''
            this._select.value = ''
            this.dispatchEvent(new CustomEvent('change', {
              value: ''
            }))
          } else if (this._disabledValue !== '') {
            // Restore the value before this became disabled!
            this.value = this._disabledValue
            this._select.value = this.value
            this._disabledValue = ''
            this.dispatchEvent(new CustomEvent('change', {
              value: this.value,
            }))
          }

          break
      }
      // TODO support attribute changes probably?
      // console.log('attributeChangedCallback', attr, oldVal, newVal)
    }

    connectedCallback() {
      this.required = (this.getAttribute('required') !== null)
      this.value = ''

      const shadow = this._shadow;

      const link = document.createElement('link');
      link.rel = "stylesheet";
      link.href = document.getElementById('customization-css').href

      const wrapper = document.createElement('form');
      wrapper.setAttribute('class', 'bc-element bc-dropdown');

      wrapper.addEventListener('submit', (ev) => {
        ev.preventDefault();
        return false;
      });

      if (this.required) {
        wrapper.classList.add('bc-required')
      }

      const inputId = 'bc-input-' + internalUniqueId;

      internalUniqueId++;

      const label = document.createElement('label');
      label.setAttribute('class', 'bc-label bc-label-dropdown');
      label.setAttribute('for', inputId);

      const select = document.createElement('select');
      select.name = 'bny-dropdown-' + inputId;
      select.setAttribute('class', 'bc-input bc-select bc-select-dropdown');
      select.setAttribute('id', inputId);
      this._select = select;

      if (this.getAttribute('label')) {
        label.textContent = this.getAttribute('label');
      } else {
        label.textContent = 'Initial';
      }

      select.required = this.required

      shadow.appendChild(link);
      shadow.appendChild(wrapper);

      wrapper.appendChild(label);
      wrapper.appendChild(select);

      if (this.hasAttribute('info')) {
        const info = document.createElement('span');
        info.setAttribute('class', 'bc-info bc-info-dropdown');
        info.textContent = this.getAttribute('info');
        wrapper.appendChild(info);
      }

      if (this.getAttribute('show-blank') !== null) {
        const opt = document.createElement('option');
        opt.value = '';
        opt.textContent = this.getAttribute('show-blank') || 'Select a Letter';
        opt.defaultSelected = true;

        select.appendChild(opt);
      }

      if (this.getAttribute('alphabet') !== null) {
        const alpha = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

        alpha.forEach(letter => {
          const opt = document.createElement('option')
          opt.value = letter;
          opt.innerText = letter;

          select.appendChild(opt);
        });
      }

      // Arbitrary option list from the customization JSON, eg. "options": ["Be Brave", "Breathe"]
      if (this.getAttribute('options') !== null) {
        let options = [];

        try {
          options = JSON.parse(this.getAttribute('options'));
        } catch (err) {
          console.error('Dropdown options attribute is not valid JSON', this.getAttribute('options'));
        }

        if ( ! Array.isArray(options)) {
          options = [];
        }

        options.forEach(text => {
          const opt = document.createElement('option')
          opt.value = text;
          opt.textContent = text;

          select.appendChild(opt);
        });
      }

      if (this.getAttribute('form') !== null) {
        select.setAttribute('form', this.getAttribute('form'))
      }

      shadow.addEventListener('change', (ev) => {
        // console.log('BNYDropDown Change', ev);
        this.value = ev.target.value;

        if (wrapper.classList.contains('bc-required-error')) {
          wrapper.classList.remove('bc-required-error')
        }

        this.dispatchEvent(new CustomEvent('change', {
          value: ev.target.value,
        }));
      });

      this.addEventListener('CustomizationsReset', () => {
        select.value = ''
        this.value = ''

        this.dispatchEvent(new CustomEvent('change', {
          value: ''
        }))
      })

      this.addEventListener('EmbellisherPreSubmit', () => {
        if (this.hasAttribute('disabled') || this.hasAttribute('hidden')) {
          return;
        }

        if (this.required && this.value === '') {
          wrapper.classList.add('bc-required-error')
        } else {
          wrapper.classList.remove('bc-required-error')
        }

        wrapper.reportValidity();
      })
    }
  }

  class BNYRadioBirthstone extends HTMLElement {
    static Months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

    _shadow = undefined

    _openWhenCompleted = undefined

    _wrapper = undefined

    _button = undefined

    _isShown = false

    _mapping = undefined

    _sessionCache = undefined

    _labels = {}

    _inputs = {}

    // constructor function runs when the element is created
    constructor() {
      super();
      // Create a shadow root to attach elements to
      this._shadow = this.attachShadow({ mode: 'open' });

      this._sessionCache = new SessionCache();
    }

    // Non-inventoried birthstone swatches are rendered per product, so a palette override set on the
    // product applies. Cached per handle - a session-wide cache would leak one product's override onto the next.
    async _cacheDefaultSwatchStyles(){
      const handle = Embellisher.ProductHandle

      if ( ! handle) {
        console.error('No product handle; cannot retrieve birthstone swatches')
        return false
      }

      const data = this._sessionCache.get('birthstoneSwatches', handle)

      if (data) {
        console.debug('[cache hit] birthstone swatch styling', handle, data)
        return true
      }

      const rsp = await fetch(`/products/${ handle }?view=bs-swatches`)

      if ( ! rsp.ok) {
        console.error('Failed to retrieve birthstone swatches for', handle, 'due to not-ok rsp')
        return false
      }

      const res = await rsp.text()

      const parser = new DOMParser()
      const dom = parser.parseFromString(res, 'text/html')

      const rawJson = dom.getElementById('core-birthstone-swatch-styling').textContent
      const parsedJson = JSON.parse(rawJson)

      console.debug('[cache miss] birthstone swatch styling', handle, parsedJson)
      this._sessionCache.put('birthstoneSwatches', handle, parsedJson)

      return true
    }

    defaultSwatchStyle(month){
      const data = this._sessionCache.get('birthstoneSwatches', Embellisher.ProductHandle) || []
      const entry = data.find(elem => elem.name === month)
      return entry ? entry.swatchStyle : ''
    }

    static get observedAttributes() {
      return [
        'disabled',
        'open-when-completed',
      ]
    }

    attributeChangedCallback(attr, oldVal, newVal) {
      // console.log('BNYRadioBirthstone attributeChanged', attr, 'oldVal=', typeof oldVal, oldVal, 'newVal=', typeof newVal, newVal)

      if (oldVal === newVal) {
        return
      }

      switch (attr) {
        case 'disabled':
          if (typeof newVal === 'string') {
            this.value = ''
            this.dispatchEvent(new CustomEvent('change', {
              value: ''
            }))
          }

          break
        case 'open-when-completed':
          this._openWhenCompleted = newVal

          break
      }
      // TODO support attribute changes probably?
      // console.log('attributeChangedCallback', attr, oldVal, newVal)
    }

    _variantForMonth(month) {
      // We aren't using inventory mapping, so there's no variant to pull
      if ( ! this._mapping) {
        console.info('No product/inventory mapping')
        return null
      }

      let parentSku = Embellisher.ActiveVariant.sku;

      if ( ! parentSku) {
        console.error('could not find parent sku');
        return null
      }

      let parentSkuMap = this._mapping[ parentSku ];

      // Parent SKU Map isn't present by using the parent SKU, let's try and find the mapping via
      // regular expressions
      if ( ! parentSkuMap) {
        parentSkuMap = handleRegexMapping(parentSku, this._mapping)
      }

      if ( ! parentSkuMap) {
        console.error('Could not find SKU Mapping for SKU:', parentSku)
        return null
      }

      let sku = parentSkuMap[ month ]

      if ( ! sku) {
        console.error('could not find sku for month', month)
        return null
      }

      sku = sku.toLowerCase();

      console.debug('sku', sku)

      const variants = this._sessionCache.get('subProducts', this.getAttribute('inventory-product'))

      console.debug('variants', variants)

      if ( ! variants) {
        console.error('Could not get subProducts for product "' + this.getAttribute('inventory-product') + '"')
        return null
      }

      const variant = variants.find(v => v.sku.toLowerCase() === sku)

      if ( ! variant) {
        return null
      }

      console.debug('variant found', month, variant)
      return variant
    }

    _isAvailable(month) {
      // console.log('_isAvailable', month)
      // console.log('inventory-product', this.getAttribute('inventory-product'))
      // console.log('inventory-mapping', this.getAttribute('inventory-mapping'))

      // We aren't inventory tracking, so we're OK!
      if ( ! this.hasAttribute('inventory-product') || ! this.hasAttribute('inventory-mapping')) {
        console.info('inventory-product and/or inventory-mapping is missing')
        return true
      }

      // Something failed here, but we want to continue showing stuff in stock
      if ( ! this._retrieveProductMapping(this.getAttribute('inventory-mapping'))) {
        console.info('failed to retrieve inventory mapping')
        return true
      }

      const variant = this._variantForMonth(month)

      if (!variant) {
        return false
      }

      // console.log('variant found', month, variant)
      return variant.availability === 'InStock'
    }

    _retrieveProductMapping(mapValue) {
      if (mapValue === null || typeof mapValue === 'undefined') {
        console.error('~1716 mapValue is not set')
        return false
      }

      if (/^[a-zA-Z0-9_-]+$/.test(mapValue)) {
        const productMaps = Embellisher.Config.product_maps

        // console.log('productMaps', productMaps);

        if (productMaps === null || typeof productMaps === 'undefined') {
          console.error('Need product map for inventory mapping key "' + mapValue + '" and no maps are defined.')
          return false
        }

        const mapping = productMaps[ mapValue ]

        if (mapping === null || typeof mapping === 'undefined') {
          // console.log(mapValue, productMaps)
          console.error('Could not find product map for inventory mapping key "' + mapValue + '" in maps:', productMaps)
          return false
        }

        this._mapping = mapping
      } else {
        this._mapping = mapping
      }

      return true
    }

    async connectedCallback() {
      // console.log('connected callback')

      await this._cacheDefaultSwatchStyles()

      this.required = (this.getAttribute('required') !== null)
      this.value = ''

      if (this.hasAttribute('open-when-completed')) {
        this._openWhenCompleted = this.getAttribute('open-when-completed')
      }

      // Get the shadow root
      const shadow = this._shadow;

      // actually get the styles if you want them
      const link = document.createElement('link');
      link.rel = "stylesheet";
      link.href = document.getElementById('customization-css').href

      const collapseButton = document.createElement('button');
      collapseButton.setAttribute('class', 'bc-collapsible');

      const collapseButtonLabelText = document.createElement('span');
      collapseButtonLabelText.setAttribute('class', 'bc-collapsible-label-text');
      collapseButtonLabelText.innerText = this.getAttribute('label') || 'Select a Birthstone';

      // this is what will receive the birthstone data
      const collapseLabelContainer = document.createElement('div');
      collapseLabelContainer.setAttribute('class', 'bc-collapsible-label-container');
      const collapseButtonLabel = document.createElement('span');
      collapseButtonLabel.setAttribute('class', 'bc-collapsible-label');
      const collapseButtonLabelBirthstoneText = document.createElement('span');
      collapseButtonLabelBirthstoneText.setAttribute('class', 'bc-birthstone-month');

      // Create a wrapper div to hold the radio buttons and label
      const wrapper = document.createElement('div');
      wrapper.setAttribute('class', 'bc-element bc-birthstone-container');

      this._wrapper = wrapper
      this._button = collapseButton

      if (this.hasAttribute('start-open')) {
        this._show(true);
      } else {
        this._hide(true)
      }

      collapseButton.addEventListener('click', () => {
        if (this._isShown) {
          this._hide();
        } else {
          this._show();
        }
      });

      // Append the label and wrapper to the shadow root
      shadow.appendChild(link);
      shadow.appendChild(collapseButton)
      collapseButton.appendChild(collapseButtonLabelText)
      collapseButton.appendChild(collapseLabelContainer)
      collapseLabelContainer.appendChild(collapseButtonLabel)
      collapseLabelContainer.appendChild(collapseButtonLabelBirthstoneText)
      shadow.appendChild(wrapper);

      const monthInputClickEv = () => {
        // console.log('monthInputClickEv')
        if (this._openWhenCompleted) {
          const ele = document.getElementById(this._openWhenCompleted)

          if (ele) {
            ele.dispatchEvent(new CustomEvent('birthstone-open'))
          } else {
            console.warn('failed to find openWhenCompleted element', this._openWhenCompleted)
          }
          //console.log('dispatched event')
        }

        this._hide();
      }

      BNYRadioBirthstone.Months.forEach(month => {
        const inStock = this._isAvailable(month)

        const label = document.createElement('label');
        label.classList.add('bc-birthstone-radio-label');

        if (!inStock) {
          label.classList.add('bc-birthstone-radio-label-disabled');
        }

        const input = document.createElement('input');
        input.classList.add('bc-birthstone-input');
        input.type = 'radio';
        input.name = 'bc-birthstone';
        input.value = month;
        input.required = this.required;

        if (!inStock) {
          input.disabled = true;
        }

        this._labels[month] = label
        this._inputs[month] = input

        let birthstoneClass = 'bc-birthstone-circle'

        // TODO maybe the circle should have a aria role?
        const circle = document.createElement('span')
        circle.classList.add(birthstoneClass)
        circle.setAttribute('id', birthstoneClass + '-' + internalUniqueId);

        // Swatch styling - check for an associated subitem variant
        const variant = this._variantForMonth(month)

        if (variant) {
          // If one exists, use the precomputed style string
          circle.style.cssText = variant.swatchStyle;
        } else {
          // If there's no subitem, fall back to the default styling
          circle.style.cssText = this.defaultSwatchStyle(month)
        }

        internalUniqueId++;

        const span = document.createElement('span')
        span.classList.add('bc-birthstone-text')
        span.textContent = month

        label.appendChild(input)
        label.appendChild(circle)
        label.appendChild(span)

        wrapper.appendChild(label)

        if (this.getAttribute('form') !== null) {
          input.setAttribute('form', this.getAttribute('form'));
        }

        input.addEventListener('click', monthInputClickEv)

        input.addEventListener('click', () => {
          const classes = collapseButtonLabel.classList;
          if (classes.length < 2){
            classes.add('bc-birthstone-circle')
          }

          if (variant){
            collapseButtonLabel.style.cssText = variant.swatchStyle;
          }
          else  {
            // If there's no subitem, fall back to the default styling
            collapseButtonLabel.style.cssText = this.defaultSwatchStyle(month)
          }
          collapseButtonLabelBirthstoneText.innerText = month;
        });
      })

      shadow.addEventListener('change', (ev) => {
        this.value = ev.target.value;

        if (collapseButtonLabelText.classList.contains('bc-required-error')) {
          collapseButtonLabelText.classList.remove('bc-required-error')
          collapseButtonLabelText.classList.remove('bc-required-error-padding-right')
        }

        this.dispatchEvent(new CustomEvent('change', {
          value: ev.target.value,
        }));
      });

      this.addEventListener('birthstone-open', () => {
        if (this.value !== '') {
          return
        }

        this._show();
      })

      this.addEventListener('other-birthstone-opened', () => {
        this._hide()
      })

      this.addEventListener('CustomizationsReset', () => {
        this._reset();

        this.dispatchEvent(new CustomEvent('change', {
          value: ''
        }))
      });

      this.addEventListener('EmbellisherPreSubmit', () => {
        const errorData = this.shadowRoot.querySelectorAll('.bc-birthstone-input');
        errorData.forEach(data => {
          if (this.required && this.value === '') {
            collapseButtonLabelText.classList.add('bc-required-error')
            collapseButtonLabelText.classList.add('bc-required-error-padding-right')
          } else {
            collapseButtonLabelText.classList.remove('bc-required-error')
            collapseButtonLabelText.classList.remove('bc-required-error-padding-right')
          }
        });
      })
    }

    _show(force = false) {
      if (this._isShown && ! force) {
        return
      }

      // console.log('SHOW', this.getAttribute('id'))

      this._isShown = true
      this._wrapper.style.display = ''
      this._wrapper.classList.remove('bc-birthstone-container-slideup')
      this._wrapper.classList.add('bc-birthstone-container-slidedown')
      this._button.classList.add('active')

      if (! force && this.hasAttribute('other-birthstones')) {
        const others = document.querySelectorAll(this.getAttribute('other-birthstones'))

        if (others) {
          others.forEach(otherBirthstone => {
            if (otherBirthstone.id !== this.getAttribute('id')) {
              otherBirthstone.dispatchEvent(new CustomEvent('other-birthstone-opened'))
            }
          })
        }
      }
    }

    _hide(force = false) {
      if ( ! this._isShown && ! force) {
        return
      }

      // console.log('HIDE', this.getAttribute('id'))

      this._isShown = false
      this._button.classList.remove('active')
      this._wrapper.classList.remove('bc-birthstone-container-slidedown')
      this._wrapper.classList.add('bc-birthstone-container-slideup')

      const hideOnAnimationEnd = () => {
        // console.log('hideOnAnimationEnd')
        this._wrapper.style.display = 'none'
      }

      this._wrapper.addEventListener('animationend', hideOnAnimationEnd, { once: true })
    }

    _reset() {
      if ( ! this.hasAttribute('start-open')) {
        this._hide();
      } else {
        this._show(true);
      }

      // Reset the selected radio button
      const input = this.shadowRoot.querySelector('.bc-birthstone-input:checked');
      if (input) {
        input.checked = false;
      }

      BNYRadioBirthstone.Months.forEach(month => {
        const inStock = this._isAvailable(month);
        // console.log('reset inStock', inStock);

        const label = this._labels[ month ]

        if ( ! inStock) {
          label.classList.add('bc-birthstone-radio-label-disabled')
        } else {
          label.classList.remove('bc-birthstone-radio-label-disabled')
        }


        const input = this._inputs[ month ]

        input.disabled = ! inStock;
      });

      // Reset the birthstone label
      const label = this.shadowRoot.querySelector('.bc-collapsible-label');
      label.classList.remove('bc-birthstone-circle');
      label.classList.value = label.classList.value.replace(/bc-birthstone-circle-\w+\s*/g, '');
      const monthElement = this.shadowRoot.querySelector('.bc-birthstone-month');
      // console.log(monthElement)
      if (monthElement) {
        monthElement.innerText = '';
      }

      // Close every open div except the first one
      if (this.hasAttribute('start-open')) {
        this._show(true);
      }

      const errorData = this.shadowRoot.querySelectorAll('.bc-birthstone-input');
      errorData.forEach(data => {
        this.value = ''
      });

      // Reset the errors
      const birthstoneErrors = this.shadowRoot.querySelectorAll('.bc-required-error');
      birthstoneErrors.forEach(data => {
        if (data.classList.contains('bc-required-error')) {
          data.classList.remove('bc-required-error')
        }
      });
    }
  }

  class BNYDropdownItemized extends HTMLElement {
    static letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    _shadow = undefined

    _mapping = undefined

    _sessionCache = undefined

    _disabledValue = ''

    _labels = {}

    _inputs = {}

    // constructor function runs when the element is created
    constructor() {
      super();
      // Create a shadow root to attach elements to
      this._shadow = this.attachShadow({ mode: 'open' });

      this._sessionCache = new SessionCache();
    }

    static get observedAttributes() {
      return [
        'id',
        'label',
        'name',
        'disabled',
        'required',
      ]
    }

    attributeChangedCallback(attr, oldVal, newVal) {
      // console.log('BNYDropdownItemized attributeChanged', attr, 'oldVal=', typeof oldVal, oldVal, 'newVal=', typeof newVal, newVal)

      if (oldVal === newVal) {
        return
      }

      switch (attr) {
        case 'required':
          break
        case 'hidden':
        case 'disabled':
          if (typeof newVal === 'string') {
            // Store the current value in a new place, so when we unhide/un-disable
            // we can restore it!
            this._disabledValue = this.value
            this.value = ''
            this._select.value = ''
            this.dispatchEvent(new CustomEvent('change', {
              value: ''
            }))
          } else if (this._disabledValue !== '') {
            // Restore the value before this became disabled!
            this.value = this._disabledValue
            this._select.value = this.value
            this._disabledValue = ''
            this.dispatchEvent(new CustomEvent('change', {
              value: this.value,
            }))
          }
          break
      }
      // TODO support attribute changes probably?
      // console.log('attributeChangedCallback', attr, oldVal, newVal)
    }

    _isAvailable(letter) {
      // console.log('_isAvailable', letter)
      // console.log('inventory-product', this.getAttribute('inventory-product'))
      // console.log('inventory-mapping', this.getAttribute('inventory-mapping'))

      // We aren't inventory tracking, so we're OK!
      if ( ! this.hasAttribute('inventory-product') || ! this.hasAttribute('inventory-mapping')) {
        console.info('inventory-product and/or inventory-mapping is missing')
        return true
      }

      // Something failed here, but we want to continue showing stuff in stock
      if ( ! this._retrieveProductMapping(this.getAttribute('inventory-mapping'))) {
        console.info('failed to retrieve inventory mapping')
        return true
      }

      let parentSku = Embellisher.ActiveVariant.sku;

      if ( ! parentSku) {
        console.error('could not find parent sku');
        return false
      }

      let parentSkuMap = this._mapping[parentSku];

      // Parent SKU Map isn't present by using the parent SKU, let's try and find the mapping via
      // regular expressions
      if ( ! parentSkuMap) {
        parentSkuMap = handleRegexMapping(parentSku, this._mapping)
      }

      if ( ! parentSkuMap) {
        console.error('Could not find SKU Mapping for SKU:', parentSku)
        return false
      }

      let sku = parentSkuMap[ letter ]

      if ( ! sku) {
        console.error('could not find sku for letter', letter)
        return false
      }

      sku = sku.toLowerCase();

      // console.log('sku', sku)

      const variants = this._sessionCache.get('subProducts', this.getAttribute('inventory-product'))

      // console.log('variants', variants)

      if ( ! variants) {
        console.error('Could not get subProducts for product "' + this.getAttribute('inventory-product') + '"')
        return false
      }

      const variant = variants.find(v => v.sku.toLowerCase() === sku)

      if ( ! variant) {
        return false
      }

      // console.log('variant availabilty found', letter, variant)
      return variant.availability === 'InStock'
    }

    _retrieveProductMapping(mapValue) {
      if (mapValue === null || typeof mapValue === 'undefined') {
        return false
      }

      if (/^[a-zA-Z0-9_-]+$/.test(mapValue)) {
        const productMaps = Embellisher.Config.product_maps

        // console.log('productMaps', productMaps);

        if (productMaps === null || typeof productMaps === 'undefined') {
          console.error('Need product map for inventory mapping key "' + mapValue + '" and no maps are defined.')
          return false
        }

        const mapping = productMaps[ mapValue ]

        if (mapping === null || typeof mapping === 'undefined') {
          // console.log(mapValue, productMaps)
          console.error('Could not find product map for inventory mapping key "' + mapValue + '" in maps:', productMaps)
          return false
        }

        this._mapping = mapping
      } else {
        this._mapping = mapping
      }

      return true
    }

    connectedCallback() {
      this.required = (this.getAttribute('required') !== null)
      this.value = ''

      // Get the shadow root
      const shadow = this._shadow;

      // actually get the styles if you want them
      const link = document.createElement('link');
      link.rel = "stylesheet";
      link.href = document.getElementById('customization-css').href

      // Create a wrapper div to hold the label and dropdown
      const wrapper = document.createElement('form');
      wrapper.setAttribute('class', 'bc-element bc-dropdown');

      if (this.required) {
        wrapper.classList.add('bc-required')
      }

      const inputId = 'bc-input-' + internalUniqueId;

      internalUniqueId++;

      const label = document.createElement('label');
      label.setAttribute('class', 'bc-label bc-label-dropdown');
      label.setAttribute('for', inputId);

      if (this.getAttribute('label')) {
        label.textContent = this.getAttribute('label');
      } else {
        label.textContent = 'Initial';
      }

      // Append the label and wrapper to the shadow root
      shadow.appendChild(link);
      shadow.appendChild(wrapper);
      wrapper.appendChild(label);

      const dropdown = document.createElement('select');
      dropdown.setAttribute('class', 'bc-input bc-select bc-select-dropdown');
      dropdown.name = 'bc-dropdown-itemized-' + inputId
      dropdown.required = this.required;
      dropdown.setAttribute('id', inputId);

      if (this.getAttribute('show-blank') !== null) {
        const opt = document.createElement('option');
        opt.value = '';
        opt.textContent = this.getAttribute('show-blank') || 'Select a Letter';
        opt.defaultSelected = true;

        dropdown.appendChild(opt);
      }

      BNYDropdownItemized.letters.forEach((letter) => {
        const inStock = this._isAvailable(letter);

        const option = document.createElement('option');
        option.value = letter;
        option.textContent = letter;

        if (!inStock) {
          option.disabled = true;
        }

        this._labels[ letter ] = label
        this._inputs[ letter ] = option

        dropdown.appendChild(option);
      });

      // Add the dropdown to the wrapper
      wrapper.appendChild(dropdown);

      shadow.addEventListener('change', (ev) => {
        this.value = ev.target.value;
        // console.log('change', ev.target.value);

        this.dispatchEvent(new CustomEvent('change', {
          value: ev.target.value,
        }));
      });

      this.addEventListener('CustomizationsReset', () => {
        this._reset();

        this.dispatchEvent(new CustomEvent('change', {
          value: ''
        }))
      });

      this.addEventListener('EmbellisherPreSubmit', () => {
        if (this.hasAttribute('disabled') || this.hasAttribute('hidden')) {
          return;
        }

        if (this.required && this.value === '') {
          wrapper.classList.add('bc-required-error')
        } else {
          wrapper.classList.remove('bc-required-error')
        }

        wrapper.reportValidity();
      })
    }

    _reset() {
      BNYDropdownItemized.letters.forEach(letter => {
        const inStock = this._isAvailable(letter);
        // console.log('reset inStock', inStock);

        const label = this._labels[ letter ]
        // console.log('fetch label for reset', label)

        const input = this._inputs[ letter ]
        // console.log('bnydropdownitemized input', input)

        input.disabled = ! inStock;
      });

      const errorData = this.shadowRoot.querySelectorAll('.bc-select-dropdown');
      errorData.forEach(data => {
        this.value = '' // clear the options behind the scenes so it doesn't grab "ghost" data
      });
      errorData[0].selectedIndex = 0 // make the select dropdown actually set to "select a..."

      // Reset the errors
      const dropdownErrors = this.shadowRoot.querySelectorAll('.bc-required-error');
      dropdownErrors.forEach(data => {
        if (data.classList.contains('bc-required-error')) {
          data.classList.remove('bc-required-error')
        }
      });
    }
  }

  class BNYTextInputWithInventory extends HTMLElement {
    _shadow = undefined;
    _mapping = undefined;
    _sessionCache = undefined;
    _errorElement = undefined;
    // _debounceTimer = null;
    // _addToCartButton = undefined;
    // _finalSaleCheckbox = undefined;

    constructor() {
      super();
      this._shadow = this.attachShadow({ mode: 'open' });
      this._sessionCache = new SessionCache();
    }

    connectedCallback() {
      this.required = (this.getAttribute('required') !== null)

      this.maxLength = this.getAttribute('maxlength') || 7;
      this.value = '';

      const shadow = this._shadow;

      const link = document.createElement('link');
      link.rel = "stylesheet";
      link.href = document.getElementById('customization-css').href;

      const wrapper = document.createElement('div');
      wrapper.setAttribute('class', 'bc-element bc-text-input');

      if (this.required) {
        wrapper.classList.add('bc-required')
      }

      const input = document.createElement('input');
      input.setAttribute('type', 'text');
      input.setAttribute('maxlength', this.maxLength);
      input.setAttribute('class', 'bc-input bc-text');
      input.setAttribute('placeholder', 'Enter text');

      this._errorElement = document.createElement('span');
      this._errorElement.setAttribute('class', 'bc-error bc-error-text');
      this._errorElement.textContent = '';

      // this._addToCartButton = document.querySelector('.add-to-cart');
      // this._finalSaleCheckbox = document.querySelector('.bny-final-sale-checkbox');

      // input.addEventListener('input', this._debounce(() => this._checkInventory(input.value), 300));
      // this._finalSaleCheckbox.addEventListener('change', () => this._checkInventory(input.value)); // re-check on checkbox change

      const label = document.createElement('label');
      label.setAttribute('class', 'bc-label bc-label-dropdown');

      if (this.getAttribute('label')) {
        label.textContent = this.getAttribute('label');
      } else {
        label.textContent = `Engraving (up to ${this.maxLength} letters)`;
      }

      wrapper.appendChild(label);
      wrapper.appendChild(input);
      wrapper.appendChild(this._errorElement);
      shadow.appendChild(link);
      shadow.appendChild(wrapper);

      shadow.addEventListener('change', (ev) => {
        this.value = ev.target.value;
        this.dispatchEvent(new CustomEvent('change', {
          value: ev.target.value,
        }));
      });

      // console.log('BNYTextInputWithInventory initialized');
      this.addEventListener('EmbellisherPreSubmit', () => {
        const isOkay = this._checkInventory(this.value);

        if ( ! isOkay) {
          this.hasError = true
          wrapper.classList.add('bc-required-error')
        } else if (this.required && this.value === '') {
          this.hasError = true
          wrapper.classList.add('bc-required-error')
        } else {
          this.hasError = false
          wrapper.classList.remove('bc-required-error')
        }
      });
    }

    _debounce(func, delay) {
      return (...args) => {
        clearTimeout(this._debounceTimer);
        this._debounceTimer = setTimeout(() => func.apply(this, args), delay);
      };
    }

    _checkInventory(value) {
      if ( ! value) { return false; }

      // console.log('Checking inventory for input:', value);

      const letters = value.toUpperCase().split('');
      const outOfStockLetters = [];

      letters.forEach(letter => {
        // console.log(`Checking availability for letter: ${letter}`);
        if ( ! this._isAvailable(letter)) {
          // console.log(`Letter ${letter} is out of stock`);
          outOfStockLetters.push(letter);
        } else {
          // console.log(`Letter ${letter} is in stock`);
        }
      });

      if (outOfStockLetters.length > 0 || !this._finalSaleCheckbox.checked) {
        this._errorElement.textContent = outOfStockLetters.length > 0 ? `Out of stock: ${outOfStockLetters.join(', ')}` : '';
        // this._addToCartButton.setAttribute('disabled', '');  // Disable the "Add to Cart" button
        return false;
      } else {
        this._errorElement.textContent = `All letters in stock.`;
        // this._addToCartButton.removeAttribute('disabled');  // Enable the "Add to Cart" button
        return true;
      }
    }

    _isAvailable(letter) {
      // console.log(`Checking inventory availability for letter: ${letter}`);

      if (!this.hasAttribute('inventory-product') || !this.hasAttribute('inventory-mapping')) {
        console.warn('inventory-product or inventory-mapping attribute is missing');
        return true;
      }

      if (!this._retrieveProductMapping(this.getAttribute('inventory-mapping'))) {
        console.warn('Failed to retrieve product mapping');
        return true;
      }

      let parentSku = Embellisher.ActiveVariant.sku;
      // console.log(`Parent SKU: ${parentSku}`);

      if (!parentSku) {
        console.error('Could not find parent SKU');
        return false;
      }

      let parentSkuMap = this._mapping[parentSku];

      // Parent SKU Map isn't present by using the parent SKU, let's try and find the mapping via
      // regular expressions
      if ( ! parentSkuMap) {
        parentSkuMap = handleRegexMapping(parentSku, this._mapping)
      }

      if ( ! parentSkuMap) {
        console.error('Could not find SKU Mapping for SKU:', parentSku)
        return false
      }

      let sku = parentSkuMap[letter];
      if (!sku) {
        console.error(`Could not find SKU for letter: ${letter}`);
        return false;
      }

      sku = sku.toUpperCase();

      // console.log(`Checking SKU: ${sku}`);

      const variants = this._sessionCache.get('subProducts', this.getAttribute('inventory-product'));
      // console.log('Variants fetched from session cache:', variants);

      if (!variants) {
        console.error(`Could not get subProducts for product "${this.getAttribute('inventory-product')}"`);
        return false;
      }

      // console.log(`Comparing SKU: ${sku} with variants in session cache...`);

      const variant = variants.find(v => v.sku.toUpperCase() === sku);

      if (variant) {
        // console.log(`Variant found: ${variant.sku} - Availability: ${variant.availability}`);
      } else {
        console.error(`No variant found for SKU: ${sku}`);
      }

      return variant ? variant.availability === 'InStock' : false;
    }

    _retrieveProductMapping(mapValue) {
      if (!mapValue) return false;

      // console.log(`Retrieving product mapping for: ${mapValue}`);

      if (/^[a-zA-Z0-9_-]+$/.test(mapValue)) {
        const productMaps = Embellisher.Config.product_maps;
        // console.log('Product maps:', productMaps);

        if (!productMaps) {
          console.error(`Need product map for inventory mapping key "${mapValue}" and no maps are defined.`);
          return false;
        }

        const mapping = productMaps[mapValue];
        if (!mapping) {
          console.error(`Could not find product map for inventory mapping key "${mapValue}" in maps:`, productMaps);
          return false;
        }

        this._mapping = mapping;
        // console.log('Product mapping retrieved:', this._mapping);
      } else {
        this._mapping = mapValue;
        // console.log('Using provided mapping:', this._mapping);
      }

      return true;
    }
  }

  class BNYRadioZodiac extends HTMLElement {
    _shadow = undefined

    _sessionCache = undefined

    _labelEles = []

    _inputEles = []

    _shadow = undefined

    _signs = [
      'Aries',
      'Taurus',
      'Gemini',
      'Cancer',
      'Leo',
      'Virgo',
      'Libra',
      'Scorpio',
      'Sagittarius',
      'Capricorn',
      'Aquarius',
      'Pisces',
    ]

    _ranges = {
      'aries': 'March 21 - April 19',
      'taurus': 'April 20 - May 20',
      'gemini': 'May 21 - June 20',
      'cancer': 'June 21 - July 22',
      'leo': 'July 23 - August 22',
      'virgo': 'August 23 - September 22',
      'libra': 'September 23 - October 22',
      'scorpio': 'October 23 - November 21',
      'sagittarius': 'November 22 - December 21',
      'capricorn': 'December 22 - January 19',
      'aquarius': 'January 20 - February 18',
      'pisces': 'February 19 - March 20',
    }

    _filler = {
      'aries': '',
      'taurus': '',
      'gemini': '',
      'cancer': '',
      'leo': '',
      'virgo': '',
      'libra': '',
      'scorpio': '',
      'sagittarius': '',
      'capricorn': '',
      'aquarius': '',
      'pisces': '',
    }

    _viewBoxes = {
      'aries': '0 0 98.2 94.04',
      'taurus': '0 0 98.04 92.96',
      'gemini': '0 0 93.84 97.42',
      'cancer': '0 0 98.66 78.61',
      'leo': '0 0 77.98 97.57',
      'virgo': '0 0 81.89 98.33',
      'libra': '0 0 98.31 89.71',
      'scorpio': '0 0 82.94 98.87',
      'sagittarius': '0 0 98.54 98.62',
      'capricorn': '0 0 98.31 97.68',
      'aquarius': '0 0 98.54 64.66',
      'pisces': '0 0 83.64 98.33',
    }

    _paths = {
      'aries': '',
      'taurus': '',
      'gemini': '',
      'cancer': '',
      'leo': '',
      'virgo': '',
      'libra': '',
      'scorpio': '',
      'sagittarius': '',
      'capricorn': '',
      'aquarius': '',
      'pisces': '',
    }

    constructor() {
      super();

      this._shadow = this.attachShadow({ mode: 'open' });
      this._sessionCache = new SessionCache();
    }

    static get observedAttributes() {
      return [
        'disabled',
        'open-when-completed',
      ];
    }

    attributeChangedCallback(attr, oldVal, newVal) {
      if (oldVal === newVal) {
        return
      }

      switch (attr) {
        case 'disabled':
          if (typeof newVal === 'string') {
            this.value = '';
            this.dispatchEvent(new CustomEvent('change', {
              value: '',
            }));
          }

          break;

        case 'open-when-completed':
          this._openWhenCompleted = newVal;
          break;
      }
    }

    connectedCallback() {
      // console.log('connected callback')

      this.required = this.hasAttribute('required')
      this.value = ''

      if (this.hasAttribute('open-when-completed')) {
        this._openWhenCompleted = this.getAttribute('open-when-completed')
      }

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = document.getElementById('customization-css').href

      const collapseButton = document.createElement('button');
      collapseButton.setAttribute('class', 'bc-collapsible');

      const collapseButtonLabelText = document.createElement('span');
      collapseButtonLabelText.setAttribute('class', 'bc-collapsible-label-text');
      collapseButtonLabelText.innerText = this.getAttribute('label') || 'Select a Zodiac Sign';

      // this is what will recieve the zodiac data
      const collapseLabelContainer = document.createElement('div');
      collapseLabelContainer.setAttribute('class', 'bc-collapsible-label-container');
      const collapseButtonLabel = document.createElement('span');
      collapseButtonLabel.setAttribute('class', 'bc-collapsible-label');
      const collapseButtonLabelZodiacText = document.createElement('span');
      collapseButtonLabelZodiacText.setAttribute('class', 'bc-zodiac-sign');

      // Create a wrapper div to hold the radio buttons and label
      const wrapper = document.createElement('div');
      wrapper.setAttribute('class', 'bc-element bc-zodiac-container');

      this._wrapper = wrapper
      this._button = collapseButton

      if (this.hasAttribute('start-open')) {
        this._show(true);
      } else {
        this._hide(true)
      }

      collapseButton.addEventListener('click', () => {
        if (this._isShown) {
          this._hide();
        } else {
          this._show();
        }
      });

      const shadow = this._shadow;

      // Append the label and wrapper to the shadow root
      shadow.appendChild(link);
      shadow.appendChild(collapseButton)
      collapseButton.appendChild(collapseButtonLabelText)
      collapseButton.appendChild(collapseLabelContainer)
      collapseLabelContainer.appendChild(collapseButtonLabel)
      collapseLabelContainer.appendChild(collapseButtonLabelZodiacText)

      shadow.appendChild(wrapper);

      const zodiacSignInputClickEv = () => {
        // console.log('zodiacSignInputClickEv')
        if (this._openWhenCompleted) {
          const ele = document.getElementById(this._openWhenCompleted)

          if (ele) {
            ele.dispatchEvent(new CustomEvent('zodiac-open'))
          } else {
            console.warn('failed to find openWhenCompleted element', this._openWhenCompleted)
          }
          //console.log('dispatched event')
        }

        this._hide();
      }

      this._signs.forEach((sign) => {
        const label = document.createElement('label');
        label.classList.add('bc-zodiac-radio-label');

        const input = document.createElement('input');
        input.classList.add('bc-zodiac-input');
        input.type = 'radio';
        input.name = 'bc-zodiac';
        input.value = sign;
        input.required = this.required;

        this._labelEles[ sign ] = label;
        this._inputEles[ sign ] = input;

        const circle = document.createElement('span');
        circle.classList.add('bc-zodiac-circle');

        const zodiacCls = 'bc-zodiac-circle-' + sign.toLowerCase();
        circle.setAttribute('id', zodiacCls + '-' + internalUniqueId);
        internalUniqueId++;
        circle.classList.add(zodiacCls);
        this._createSvgIcon(sign, circle);

        const span = document.createElement('span');
        span.classList.add('bc-zodiac-text');
        span.textContent = sign;

        label.appendChild(input);
        label.appendChild(circle);
        label.appendChild(span);

        wrapper.appendChild(label);

        if (this.getAttribute('form') !== null) {
          input.setAttribute('form', this.getAttribute('form'));
        }

        input.addEventListener('click', zodiacSignInputClickEv);

        input.addEventListener('click', () => {
          const classes = collapseButtonLabel.classList;

          const svg = collapseButtonLabel.querySelector('svg');
          if (svg) {
            collapseButtonLabel.removeChild(svg);
          }

          this._createSvgIcon(sign, collapseButtonLabel);

          if (classes.length > 2) {
            classes.replace(classes[2], zodiacCls);

          } else {
            collapseButtonLabel.classList.add('bc-zodiac-circle');
            collapseButtonLabel.classList.add(zodiacCls);
          }

          collapseButtonLabelZodiacText.textContent = sign;
        });
      });

      shadow.addEventListener('change', (ev) => {
        this.value = ev.target.value;

        if (collapseButtonLabelText.classList.contains('bc-required-error')) {
          collapseButtonLabelText.classList.remove('bc-required-error');
          collapseButtonLabelText.classList.remove('bc-required-error-padding-right');
        }

        this.dispatchEvent(new CustomEvent('change', {
          value: ev.target.value,
        }));
      });

      this.addEventListener('zodiac-open', () => {
        if (this.value !== '') {
          return;
        }

        this._show();
      });

      this.addEventListener('other-zodiac-opened', () => {
        this._hide();
      });

      this.addEventListener('CustomizationsReset', () => {
        this._reset();

        this.dispatchEvent(new CustomEvent('change', {
          value: '',
        }));
      });

      this.addEventListener('EmbellisherPreSubmit', () => {
        const errorData = this.shadowRoot.querySelectorAll('.bc-zodiac-input');

        errorData.forEach(() => {
          if (this.required && this.value === '') {
            collapseButtonLabelText.classList.add('bc-required-error')
            collapseButtonLabelText.classList.add('bc-required-error-padding-right')
          } else {
            collapseButtonLabelText.classList.remove('bc-required-error')
            collapseButtonLabelText.classList.remove('bc-required-error-padding-right')
          }
        });
      });
    }

    _show(force = false) {
      if (this._isShown && ! force) {
        return
      }

      // console.log('SHOW', this.getAttribute('id'))

      this._isShown = true
      this._wrapper.style.display = ''
      this._wrapper.classList.remove('bc-zodiac-container-slideup')
      this._wrapper.classList.add('bc-zodiac-container-slidedown')
      this._button.classList.add('active')

      if (! force && this.hasAttribute('other-zodiacs')) {
        const others = document.querySelectorAll(this.getAttribute('other-zodiacs'))

        if (others) {
          others.forEach(otherZodiacs => {
            if (otherZodiacs.id !== this.getAttribute('id')) {
              otherZodiacs.dispatchEvent(new CustomEvent('other-zodiac-opened'))
            }
          })
        }
      }
    }

    _hide(force = false) {
      if ( ! this._isShown && ! force) {
        return
      }

      // console.log('HIDE', this.getAttribute('id'))

      this._isShown = false
      this._button.classList.remove('active')
      this._wrapper.classList.remove('bc-zodiac-container-slidedown')
      this._wrapper.classList.add('bc-zodiac-container-slideup')

      const hideOnAnimationEnd = () => {
        // console.log('hideOnAnimationEnd')
        this._wrapper.style.display = 'none'
      }

      this._wrapper.addEventListener('animationend', hideOnAnimationEnd, { once: true })
    }

    _reset() {
      if ( ! this.hasAttribute('start-open')) {
        this._hide();
      } else {
        this._show(true);
      }

      // Reset the selected radio button
      const input = this.shadowRoot.querySelector('.bc-zodiac-input:checked');
      if (input) {
        input.checked = false;
      }

      // Reset the zodiac label
      const label = this.shadowRoot.querySelector('.bc-collapsible-label');
      label.classList.remove('bc-zodiac-circle');
      label.classList.value = label.classList.value.replace(/bc-zodiac-circle-\w+\s*/g, '');
      const zodiacEle = this.shadowRoot.querySelector('.bc-zodiac-sign');

      if (zodiacEle) {
        zodiacEle.textContent = '';
      }

      // Close every open div except the first one
      if (this.hasAttribute('start-open')) {
        this._show(true);
      }

      this.value = '';

      // Reset the errors
      const zodiacErrors = this.shadowRoot.querySelectorAll('.bc-required-error');
      zodiacErrors.forEach(ele => {
        if (ele.classList.contains('bc-required-error')) {
          ele.classList.remove('bc-required-error');
        }
      });
    }

    _createSvgIcon(sign, ele) {
      sign = sign.toLowerCase();

      const d = this._signPaths(sign);

      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')

      path.setAttribute('d', d);

      svg.classList.add('bc-zodiac-sign-svg');
      svg.classList.add('bc-zodiac-sign-svg-' + sign);
      svg.setAttribute('viewBox', this._viewBoxes[ sign ]);

      svg.appendChild(path);
      ele.appendChild(svg);
    }

    _signPaths(sign) {
      sign = sign.toLowerCase()

      let path = ''

      // Signs pulled from https://commons.wikimedia.org/wiki/File:Astro_signs.svg
      // Copyright under CC BY 3.0 https://creativecommons.org/licenses/by/3.0/deed.en

      switch (sign) {
        case 'aquarius':
          path = 'm33.26,25.02l-7.18-12.39L4.64,25.02,0,17.03,29.54,0l7.12,12.39L58.16,0l7.12,12.39L86.77,0l11.77,20.38-8.05,4.64-7.18-12.39-21.43,12.39-7.18-12.39-21.43,12.39m0,39.64l-7.18-12.39-21.43,12.39-4.64-7.99,29.54-17.03,7.12,12.39,21.49-12.39,7.12,12.39,21.49-12.39,11.77,20.38-8.05,4.64-7.18-12.39-21.43,12.39-7.18-12.39-21.43,12.39'
          break
        case 'aries':
          path = 'm44.47,94.04v-7.49c0-5.9-1.27-16.42-3.82-31.55-1.15-7.14-3.04-14.56-5.67-22.27-2.67-7.84-5.47-13.98-8.39-18.44-2.26-3.38-4.96-5.07-8.08-5.07-3.54,0-6,1.36-7.4,4.08-1.27,2.52-1.91,5.26-1.91,8.23,0,6.27,2.24,11.94,6.72,17.01H5.43C1.81,32.98,0,27.1,0,20.91c0-6.48,1.73-11.55,5.18-15.22C8.76,1.9,13.1,0,18.2,0c6.58,0,11.72,2.72,15.42,8.17,4.19,6.15,7.69,13.61,10.49,22.4,1.97,6.39,3.64,13.47,5,21.22,1.36-7.75,3.02-14.83,5-21.22,2.63-8.58,6.13-16.04,10.49-22.4C68.28,2.72,73.42,0,80,0c5.1,0,9.44,1.9,13.02,5.69,3.45,3.67,5.18,8.74,5.18,15.22,0,6.19-1.81,12.06-5.43,17.63h-10.49c4.48-5.07,6.72-10.74,6.72-17.01,0-2.97-.64-5.71-1.91-8.23-1.4-2.72-3.87-4.08-7.4-4.08-3.13,0-5.82,1.69-8.08,5.07-2.92,4.45-5.72,10.6-8.39,18.44-2.63,7.71-4.52,15.14-5.67,22.27-2.55,15.14-3.82,25.66-3.82,31.55v7.49h-9.25'
          break
        case 'cancer':
          path = 'm0,55.63c4.14,2.64,8.11,4.77,11.93,6.41,9.73,4.23,20.52,6.34,32.39,6.34,7.45,0,14.52-.84,21.2-2.52-.59-.5-1.14-1-1.64-1.5-2.05-2.09-3.55-4.32-4.5-6.68-1-2.45-1.5-5.07-1.5-7.84,0-2.73.5-5.32,1.5-7.77,1.05-2.59,2.55-4.82,4.5-6.68,2.14-2.05,4.34-3.55,6.61-4.5,2.36-1,4.95-1.5,7.77-1.5,2.95,0,5.55.5,7.77,1.5,2.64,1.18,4.84,2.68,6.61,4.5,2.05,2.09,3.55,4.32,4.5,6.68,1,2.45,1.5,5.05,1.5,7.77,0,2.73-.5,5.34-1.5,7.84-1.09,2.73-2.82,5.07-5.18,7.02-3.32,2.73-7.11,5-11.39,6.82-11.09,4.73-23.18,7.09-36.27,7.09-13.41,0-25.5-2.36-36.27-7.09-2.77-1.23-5.45-2.52-8.05-3.89v-12m74.38,3.75c1.18.5,2.48.75,3.89.75,1.41,0,2.7-.25,3.89-.75,1.23-.55,2.34-1.3,3.34-2.25.91-.91,1.66-2.02,2.25-3.34.5-1.23.75-2.55.75-3.95,0-1.36-.25-2.66-.75-3.89-.5-1.18-1.25-2.3-2.25-3.34-.86-.86-1.98-1.61-3.34-2.25-1.18-.5-2.48-.75-3.89-.75-1.41,0-2.7.25-3.89.75-1.23.55-2.34,1.3-3.34,2.25-.91.91-1.66,2.02-2.25,3.34-.5,1.23-.75,2.52-.75,3.89,0,1.41.25,2.73.75,3.95.5,1.18,1.25,2.3,2.25,3.34.86.86,1.98,1.61,3.34,2.25m24.27-36.41c-4.14-2.64-8.11-4.77-11.93-6.41-9.73-4.23-20.52-6.34-32.39-6.34-7.45,0-14.52.84-21.2,2.52.59.5,1.14,1,1.64,1.5,2.05,2.09,3.55,4.32,4.5,6.68,1,2.45,1.5,5.07,1.5,7.84,0,2.73-.5,5.32-1.5,7.77-1.05,2.59-2.55,4.82-4.5,6.68-2.14,2.05-4.34,3.55-6.61,4.5-2.36,1-4.95,1.5-7.77,1.5-2.95,0-5.55-.5-7.77-1.5-2.64-1.18-4.84-2.68-6.61-4.5-2.05-2.09-3.55-4.32-4.5-6.68-1-2.45-1.5-5.05-1.5-7.77s.5-5.34,1.5-7.84c1.09-2.73,2.82-5.07,5.18-7.02,3.32-2.73,7.11-5,11.39-6.82C29.16,2.36,41.25,0,54.34,0c13.41,0,25.5,2.36,36.27,7.09,2.77,1.23,5.45,2.52,8.05,3.89v12m-74.38-3.75c-1.18-.5-2.48-.75-3.89-.75-1.41,0-2.7.25-3.89.75-1.23.55-2.34,1.3-3.34,2.25-.91.91-1.66,2.02-2.25,3.34-.5,1.23-.75,2.55-.75,3.95s.25,2.66.75,3.89c.5,1.18,1.25,2.3,2.25,3.34.86.86,1.98,1.61,3.34,2.25,1.18.5,2.48.75,3.89.75,1.41,0,2.7-.25,3.89-.75,1.23-.55,2.34-1.3,3.34-2.25.91-.91,1.66-2.02,2.25-3.34.5-1.23.75-2.52.75-3.89s-.25-2.73-.75-3.95c-.5-1.18-1.25-2.3-2.25-3.34-.86-.86-1.98-1.61-3.34-2.25'
          break
        case 'capricorn':
          path = 'm51.84,67.79c-.76-1.14-1.47-2.33-2.14-3.59-3.41-6.39-5.11-13.43-5.11-21.13v-5.3c0-7.48-.44-13.14-1.32-16.96-1.35-5.89-3.01-8.83-4.98-8.83-2.02,0-4.81,3.76-8.39,11.29-2.82,5.93-4.23,12.23-4.23,18.92v15.83h-9.46v-20.24c0-7.44-.55-13.1-1.64-16.96-1.68-5.89-5.02-8.83-10.03-8.83H0V0h5.3c6.35,0,11.2,2.86,14.57,8.58,1.85,3.15,3.09,6.26,3.72,9.33,1.26-3.74,2.94-6.98,5.04-9.71C32.88,2.73,36.55,0,39.67,0c2.98,0,6.16,2.86,9.52,8.58,1.81,3.03,2.94,6.14,3.41,9.33.84,5.84,1.26,10.87,1.26,15.07v7c0,6.01.8,11.16,2.4,15.45,1.56-3.41,3.32-6.12,5.3-8.13,1.89-1.93,4.41-3.53,7.57-4.79,2.52-1.01,5.44-1.51,8.77-1.51,2.82,0,5.42.5,7.82,1.51,2.44,1.01,4.65,2.5,6.62,4.48,1.93,1.93,3.43,4.16,4.48,6.68,1.01,2.48,1.51,5.11,1.51,7.88,0,2.73-.5,5.34-1.51,7.82-1.05,2.52-2.54,4.75-4.48,6.68-1.81,1.81-4.02,3.3-6.62,4.48-2.23,1.01-5.05,1.51-8.45,1.51s-6.68-.5-9.71-1.51c-3.07-1.01-5.91-2.56-8.51-4.67-.71,1.85-1.47,3.59-2.27,5.23-1.85,3.7-4.06,6.62-6.62,8.77-3.32,2.77-6.41,4.71-9.27,5.8-3.45,1.35-7.06,2.02-10.85,2.02h-3.53v-9.46h3.53c2.82,0,5.21-.44,7.19-1.32,2.44-1.05,4.44-2.31,5.99-3.78,1.77-1.6,3.24-3.47,4.41-5.61,1.35-2.44,2.75-5.68,4.23-9.71m10.72-2.46c3.15,3.45,6.2,5.59,9.14,6.43,1.89.55,3.76.82,5.61.82,1.98,0,3.57-.27,4.79-.82,1.35-.59,2.54-1.39,3.59-2.4,1.01-1.01,1.83-2.21,2.46-3.59.55-1.22.82-2.63.82-4.23,0-1.51-.27-2.94-.82-4.29-.5-1.26-1.32-2.46-2.46-3.59-1.05-1.01-2.25-1.81-3.59-2.4-1.26-.55-2.65-.82-4.16-.82-1.43,0-2.92.27-4.48.82-1.72.63-3.03,1.43-3.91,2.4-2.98,3.36-5.32,7.25-7,11.67'
          break
        case 'gemini':
          path = 'm73.34,84.09c7,.96,13.84,2.29,20.5,3.96v9.37c-14.84-3.73-30.48-5.6-46.92-5.6s-32.08,1.87-46.92,5.6v-9.37c6.67-1.68,13.5-3,20.5-3.96V13.33c-7-.96-13.84-2.29-20.5-3.96V0c14.84,3.73,30.48,5.6,46.92,5.6,16.44,0,32.08-1.87,46.92-5.6v9.37c-6.67,1.68-13.5,3-20.5,3.96v70.76M63.9,14.34c-5.58.46-11.24.69-16.98.69-5.74,0-11.41-.23-16.98-.69v68.74c5.58-.46,11.24-.69,16.98-.69,5.74,0,11.4.23,16.98.69V14.34'
          break
        case 'leo':
          path = 'm54.04,75.96c-.38,1.47-.57,2.69-.57,3.65,0,1.47.19,2.67.57,3.59.5,1.09,1.09,1.95,1.76,2.58.76.71,1.6,1.28,2.52,1.7.92.42,2.35.63,4.28.63,1.72,0,3.23-.29,4.54-.88,1.64-.71,3.02-1.62,4.16-2.71l6.68,6.68c-1.85,1.76-4.28,3.36-7.31,4.79-2.18,1.05-4.87,1.57-8.06,1.57s-5.84-.44-7.81-1.32c-2.27-1.01-4.16-2.27-5.67-3.78-1.68-1.68-2.94-3.55-3.78-5.61-.84-2.1-1.26-4.51-1.26-7.24,0-2.98.44-5.58,1.32-7.81,3.19-7.85,6.3-13.77,9.32-17.76,3.78-5,6.7-10.31,8.76-15.94.92-2.48,1.39-5.29,1.39-8.44,0-3.4-.46-6.24-1.39-8.5-.88-2.18-2.27-4.24-4.16-6.17-1.64-1.68-3.67-3.07-6.11-4.16-2.06-.92-4.45-1.39-7.18-1.39-2.6,0-5,.46-7.18,1.39-2.1.88-4.14,2.27-6.11,4.16-1.81,1.72-3.19,3.78-4.16,6.17-.92,2.27-1.39,4.68-1.39,7.24,0,2.73.46,5.12,1.39,7.18,1.13,2.48,2.75,5.59,4.85,9.32,2.81,4.91,4.22,9.57,4.22,13.98,0,2.52-.46,4.91-1.39,7.18-.88,2.18-2.27,4.24-4.16,6.17-1.64,1.68-3.67,3.07-6.11,4.16-2.06.92-4.45,1.39-7.18,1.39s-5-.46-7.18-1.39c-2.1-.88-4.14-2.27-6.11-4.16-1.81-1.72-3.19-3.78-4.16-6.17C.46,63.81,0,61.41,0,58.89c0-2.56.46-4.98,1.39-7.24.88-2.18,2.27-4.24,4.16-6.17,1.64-1.68,3.67-3.07,6.11-4.16,2.06-.92,4.45-1.39,7.18-1.39h1.07c-1.43-3.23-2.14-7.05-2.14-11.46,0-4.07.69-7.73,2.08-10.96,1.51-3.53,3.59-6.61,6.24-9.26,2.65-2.65,5.71-4.7,9.2-6.17C38.55.69,42.14,0,46.04,0c4.12,0,7.71.69,10.77,2.08,3.65,1.64,6.72,3.7,9.2,6.17,2.77,2.77,4.85,5.86,6.24,9.26,1.39,3.4,2.08,7.47,2.08,12.22,0,4.7-.69,8.71-2.08,12.03-2.6,6.34-5.82,12.18-9.64,17.51-4.33,6.17-7.18,11.74-8.57,16.69m-31.62-25.89c-1.09-.46-2.29-.69-3.59-.69-1.3,0-2.5.23-3.59.69-1.13.5-2.16,1.2-3.09,2.08-.92.97-1.62,1.99-2.08,3.09-.46,1.13-.69,2.35-.69,3.65,0,1.26.23,2.46.69,3.59.46,1.09,1.15,2.12,2.08,3.09.92.88,1.95,1.57,3.09,2.08,1.09.46,2.29.69,3.59.69,1.3,0,2.5-.23,3.59-.69,1.13-.5,2.16-1.2,3.09-2.08.92-.97,1.62-1.99,2.08-3.09.46-1.13.69-2.33.69-3.59,0-1.3-.23-2.52-.69-3.65-.46-1.09-1.15-2.12-2.08-3.09-.92-.88-1.95-1.57-3.09-2.08'
          break
        case 'libra':
          path = 'm37.62,59.96H0v-9.92h22.67c-1.58-2.03-2.9-4.23-3.95-6.61-1.63-3.75-2.44-7.71-2.44-11.9,0-4.32.81-8.35,2.44-12.1,1.71-3.88,4.13-7.29,7.25-10.25,3.12-2.95,6.68-5.24,10.67-6.88C40.46.77,44.63,0,49.16,0c4.74,0,8.92.77,12.52,2.31,4.17,1.81,7.73,4.1,10.67,6.88,3.12,2.95,5.53,6.37,7.25,10.25,1.63,3.75,2.44,7.78,2.44,12.1,0,4.19-.81,8.15-2.44,11.9-1.05,2.38-2.37,4.58-3.95,6.61h22.67v9.92h-37.69v-9.92c1.67-.93,3.25-2.05,4.74-3.37,2.15-1.9,3.84-4.23,5.07-7.01,1.14-2.6,1.71-5.33,1.71-8.2,0-2.91-.57-5.66-1.71-8.26-1.19-2.6-2.88-4.94-5.07-7.01-2.06-1.9-4.55-3.46-7.45-4.69-2.5-1.06-5.43-1.59-8.76-1.59-3.16,0-6.08.53-8.76,1.59-2.77,1.1-5.25,2.67-7.45,4.69-2.2,2.07-3.89,4.41-5.07,7.01-1.14,2.6-1.71,5.35-1.71,8.26,0,2.86.57,5.6,1.71,8.2,1.19,2.6,2.88,4.94,5.07,7.01,1.36,1.28,2.92,2.4,4.68,3.37v9.92M0,89.71v-9.92h98.31v9.92H0'
          break
        case 'pisces':
          path = 'm52.16,54.14h-20.68c-.53,8.69-2.35,16.79-5.47,24.3-2.85,6.89-6.98,13.52-12.38,19.89H0c8.03-7.82,13.65-15.72,16.86-23.71,2.63-6.5,4.19-13.33,4.68-20.48H1.98v-9.88h19.56c-.48-7.16-2.04-13.98-4.68-20.48C13.61,15.78,7.99,7.86,0,0h13.63c5.36,6.37,9.48,13.02,12.38,19.96,3.16,7.51,4.98,15.61,5.47,24.3h20.68c.48-8.69,2.3-16.79,5.47-24.3,2.9-6.94,7.02-13.59,12.38-19.96h13.63c-7.99,7.86-13.61,15.78-16.86,23.77-2.63,6.5-4.19,13.33-4.68,20.48h18.9v9.88h-18.9c.48,7.16,2.04,13.98,4.68,20.48,3.2,7.99,8.82,15.89,16.86,23.71h-13.63c-5.4-6.37-9.53-13-12.38-19.89-3.12-7.64-4.94-15.74-5.47-24.3'
          break
        case 'sagittarius':
          path = 'm86.77,20.16l-42.36,42.36,21.26,21.26-8.32,8.32-21.26-21.26-27.77,27.77L0,90.3l27.77-27.77L6.51,41.27l8.32-8.32,21.26,21.26L78.53,11.77h-32.24V0h52.25v52.25h-11.77V20.16'
          break
        case 'scorpio':
          path = 'm69.15,92.18c-2.62,0-4.73-.36-6.33-1.07-1.84-.82-3.37-1.84-4.6-3.06-1.36-1.36-2.38-2.88-3.06-4.55-.68-1.7-1.02-3.68-1.02-5.92V30.59c0-6.06-.36-10.64-1.07-13.74-1.09-4.77-2.43-7.15-4.03-7.15-1.63,0-3.9,3.05-6.79,9.14-2.28,4.8-3.42,9.91-3.42,15.32v43.46h-7.66V30.59c0-6.03-.36-10.61-1.07-13.74-1.06-4.77-2.4-7.15-4.03-7.15-1.63,0-3.9,3.05-6.79,9.14-2.28,4.8-3.42,9.91-3.42,15.32v43.46h-7.66V30.59c0-7.12-.92-13.43-2.76-18.95C4.36,8.48,2.55,5.28,0,2.04h7.86c1.33,1.33,2.5,2.96,3.52,4.9,1.16,2.25,2.08,4.77,2.76,7.56,1.02-3.03,2.38-5.65,4.09-7.86C21.67,2.21,24.48,0,26.66,0c2.42,0,4.99,2.32,7.71,6.95,1.06,1.77,1.97,4.29,2.76,7.56,1.02-3.03,2.38-5.65,4.09-7.86C44.65,2.21,47.63,0,50.15,0c2.42,0,4.99,2.32,7.71,6.95,1.46,2.45,2.38,4.97,2.76,7.56.68,4.73,1.02,8.8,1.02,12.21v50.92c0,1.29.15,2.26.46,2.91.41.89.89,1.58,1.43,2.09.61.58,1.29,1.04,2.04,1.38.75.34,1.91.51,3.47.51h2.96v-6.64l10.93,10.47-10.93,10.52v-6.69h-2.86'
          break
        case 'taurus':
          path = 'm20.17,22.29c-1.12-2.6-2.73-4.91-4.81-6.94-1.92-1.87-4.27-3.41-7.06-4.63-2.41-1.06-5.18-1.58-8.31-1.58V0c4.29,0,8.24.75,11.86,2.25,3.79,1.58,7.16,3.8,10.12,6.64,3,2.88,5.29,6.19,6.87,9.93,1.12,2.6,2.73,4.91,4.81,6.94,1.91,1.87,4.27,3.41,7.06,4.63,2.41,1.06,5.18,1.58,8.31,1.58,3,0,5.77-.53,8.31-1.58,2.66-1.1,5.02-2.64,7.06-4.63,2.08-2.03,3.68-4.35,4.81-6.94,1.58-3.74,3.87-7.05,6.87-9.93,2.96-2.84,6.33-5.06,10.12-6.64C89.8.75,93.75,0,98.04,0v9.14c-3.12,0-5.89.53-8.31,1.58-2.79,1.22-5.14,2.76-7.06,4.63-2.08,2.03-3.68,4.35-4.81,6.94-1.58,3.7-3.87,7.01-6.87,9.93-1.46,1.42-3.35,2.86-5.68,4.32,2.33,1.46,4.23,2.9,5.68,4.32,3,2.92,5.29,6.23,6.87,9.93,1.54,3.65,2.31,7.57,2.31,11.76,0,4.06-.77,7.92-2.31,11.57-1.62,3.74-3.91,7.05-6.87,9.93-2.96,2.84-6.33,5.06-10.12,6.64-3.62,1.5-7.58,2.25-11.86,2.25s-8.45-.75-11.86-2.25c-3.95-1.75-7.33-3.96-10.12-6.64-2.96-2.88-5.25-6.19-6.87-9.93-1.54-3.65-2.31-7.51-2.31-11.57,0-4.18.77-8.1,2.31-11.76,1.67-3.94,3.95-7.25,6.87-9.93,1.79-1.66,3.71-3.11,5.74-4.32-2.08-1.22-4-2.66-5.74-4.32-2.91-2.76-5.2-6.07-6.87-9.93m37.16,20.41c-2.54-1.06-5.31-1.58-8.31-1.58-3,0-5.77.53-8.31,1.58-2.58,1.14-4.93,2.68-7.06,4.63-2.16,2.19-3.77,4.51-4.81,6.94-1.08,2.56-1.62,5.32-1.62,8.28,0,2.84.54,5.54,1.62,8.1,1.04,2.44,2.64,4.75,4.81,6.94,2.12,1.95,4.48,3.49,7.06,4.63,2.54,1.06,5.31,1.58,8.31,1.58s5.77-.53,8.31-1.58c2.58-1.14,4.93-2.68,7.06-4.63,2.16-2.19,3.77-4.51,4.81-6.94,1.08-2.56,1.62-5.26,1.62-8.1,0-2.96-.54-5.73-1.62-8.28-1.04-2.44-2.64-4.75-4.81-6.94-2.12-1.95-4.48-3.49-7.06-4.63'
          break
        case 'virgo':
          path = 'm62.36,74.67c3.81-3.85,6.73-8.23,8.76-13.14,2.03-4.95,3.04-10.17,3.04-15.67,0-4.78-.29-8.25-.88-10.41-.89-3.33-2.13-5-3.71-5-.89,0-2.15,1.61-3.76,4.84-2.3,4.6-3.45,9.76-3.45,15.46v23.91m-6.18,14.22c-1.48.79-2.99,1.53-4.54,2.22-3.81,1.68-7.97,2.77-12.47,3.25v-7.78c3.4-.48,6.58-1.36,9.53-2.63,2.13-.93,4.14-1.99,6.03-3.2-.07-.79-.1-1.61-.1-2.47V30.87c0-6.12-.36-10.74-1.08-13.86-1.1-4.81-2.46-7.21-4.07-7.21-1.65,0-3.93,3.07-6.85,9.22-2.3,4.84-3.45,10-3.45,15.46v43.86h-7.73V30.87c0-6.08-.36-10.7-1.08-13.86-1.07-4.81-2.42-7.21-4.07-7.21-1.65,0-3.93,3.07-6.85,9.22-2.3,4.84-3.45,10-3.45,15.46v43.86h-7.73V30.87c0-7.18-.93-13.55-2.78-19.12C4.4,8.55,2.58,5.33,0,2.06h7.94c1.34,1.34,2.53,2.99,3.56,4.95,1.17,2.27,2.1,4.81,2.78,7.63,1.03-3.06,2.4-5.7,4.12-7.94C21.87,2.23,24.7,0,26.9,0c2.44,0,5.03,2.34,7.78,7.01,1.07,1.79,1.99,4.33,2.78,7.63,1.03-3.06,2.4-5.7,4.12-7.94C45.06,2.23,48.06,0,50.61,0c2.44,0,5.03,2.34,7.78,7.01,1.48,2.47,2.4,5.02,2.78,7.63.52,3.61.86,7.71,1.03,12.32.69-1.41,1.55-2.73,2.58-3.97,2.51-2.99,4.71-4.48,6.6-4.48,2.75,0,5.14,2.71,7.16,8.14,2.23,5.98,3.35,12.39,3.35,19.22,0,6.7-1.2,12.9-3.61,18.6-2.61,6.18-6.2,11.51-10.77,15.98-1.44,1.41-2.95,2.73-4.54,3.97.38,1.61.88,3.18,1.49,4.69,1.34,3.26,3.42,6.34,6.24,9.22h-10c-1.55-2.47-2.68-4.57-3.4-6.29-.41-1.03-.79-2.08-1.13-3.14'
          break
      }

      return path
    }
  }

  class BNYTextDate extends HTMLElement {
    _shadow = undefined

    _value = undefined

    _monthSelect = undefined

    _daySelect = undefined

    _dayMax = -1

    _yearSelect = undefined

    constructor() {
      super();

      this._shadow = this.attachShadow({ mode: 'open' })
      this._value = luxon.DateTime.now()
    }

    static get observedAttributes() {
      return [
        'id',
        'label',
        'name',
        'required',
        'type',
      ]
    }

    attributeChangedCallback(attr, oldVal, newVal) {
      // TODO support attribute changes probably?
      // console.log('attributeChangedCallback', attr, oldVal, newVal)
    }

    _getType() {
      const attrType = this.getAttribute('type')

      let outType = 'cart'

      if (attrType !== null && (attrType === 'roman' || attrType === 'cart')) {
        outType = attrType
      }

      return outType
    }

    _makeWrapper(type) {
      const ele = document.createElement('div')
      ele.setAttribute('class', 'bc-element bc-element-input bc-element-input-date bc-element-input-' + type)

      return ele
    }

    _makeSelect(label, type) {
      const ele = document.createElement('select')
      ele.setAttribute('class', 'bc-input bc-input-date bc-input-' + type)
      ele.setAttribute('aria-label', label)

      if (this.required) {
        ele.required = true
      }

      return ele
    }

    _makeMonthInput() {
      const wrap = this._makeWrapper('month')
      const select = this._makeSelect('Month', 'month')

      wrap.appendChild(select)

      luxon.Info.months().forEach((month, idx) => {
        const monthNum = idx + 1

        const opt = document.createElement('option')
        opt.value = monthNum
        opt.textContent = month

        if (monthNum === this._value.month) {
          opt.selected = true
        }

        select.appendChild(opt)
      })

      this._monthSelect = select

      return wrap
    }

    _makeDayInput() {
      const wrap = this._makeWrapper('day')
      const select = this._makeSelect('Day', 'day')
      select.classList.add('bc-input-center')

      wrap.appendChild(select)

      const days = this._value.daysInMonth

      for (let k = 1; k <= 31; k++) {
        const opt = document.createElement('option')
        opt.value = k
        opt.textContent = k

        if (k === this._value.day) {
          opt.selected = true
        }

        if (k > days) {
          opt.disabled = true
          opt.selected = false
          opt.style.display = 'none'
        }

        select.appendChild(opt)
      }

      this._daySelect = select

      return wrap
    }

    _makeYearInput() {
      const wrap = this._makeWrapper('year')
      const select = this._makeSelect('Year', 'year')
      select.classList.add('bc-input-center')

      wrap.appendChild(select)

      const maxDT = this._maxDateTime()
      for (let year = 1901; year <= maxDT.year; year++) {
        const opt = document.createElement('option')
        opt.value = year
        opt.textContent = year

        if (year === this._value.year) {
          opt.selected = true
        }

        select.appendChild(opt)
      }

      this._yearSelect = select

      return wrap
    }

    _reset() {
      this._value = luxon.DateTime.now()
      this.value = formatDate(this._value, this._getType())

      this._changeInputsTo(this._value)
    }

    _changeInputsTo(dt) {
      this._monthSelect.querySelectorAll('option').forEach(opt => {
        if (parseInt(opt.value) === dt.month) {
          opt.selected = true
        } else {
          opt.selected = false
        }
      })

      this._daySelect.querySelectorAll('option').forEach(opt => {
        const optVal = parseInt(opt.value)

        if (optVal <= dt.daysInMonth) {
          opt.disabled = false
          opt.style.display = ''
          opt.selected = optVal === dt.day
        } else {
          opt.disabled = true
          opt.style.display = 'none'
        }
      })

      this._yearSelect.querySelectorAll('option').forEach(opt => {
        const optVal = parseInt(opt.value)

        opt.selected = optVal === dt.year
      })
    }

    _handleChangeEv() {
      const monthNum = parseInt(this._monthSelect.value)
      const dayNum = parseInt(this._daySelect.value)
      const yearNum = parseInt(this._yearSelect.value)

      let dt = luxon.DateTime.local(yearNum, monthNum, dayNum)

      if ( ! dt.isValid) {
        dt = luxon.DateTime.local(yearNum, monthNum, 1)

        // If our currently set month is valid and it's a month later (or current)
        // than the month we're switching to, we'll switch to the last day of the month.
        if (this._value.isValid && this._value.month >= monthNum) {
          dt = dt.set({ day: dt.endOf('month').day })
        }
      }

      if ( ! dt.isValid) {
        dt = luxon.DateTime.local()
      }

      this.value = formatDate(dt, this._getType())
      this._value = dt

      this._changeInputsTo(dt)
      this.dispatchEvent(new CustomEvent('change', {
        value: this.value,
      }))
    }

    connectedCallback() {
      this.required = (this.getAttribute('required') !== null)
      this.value = formatDate(this._value, this._getType())

      const shadow = this._shadow

      const link = document.createElement('link');
      link.rel = 'stylesheet'
      link.href = document.getElementById('customization-css').href

      const baseWrapper = document.createElement('div')
      baseWrapper.setAttribute('class', 'bc-element bc-textdate')

      if (this.required) {
        baseWrapper.classList.add('bc-required')
      }

      const divLabel = document.createElement('div')
      divLabel.setAttribute('class', 'bc-label bc-label-textdate')
      divLabel.textContent = 'Date:'

      if (this.hasAttribute('label')) {
        divLabel.textContent = this.getAttribute('label')
      }

      const inputsWrapper = document.createElement('div')
      inputsWrapper.setAttribute('class', 'bc-elements bc-elements-datetime')

      baseWrapper.appendChild(divLabel)

      const month = this._makeMonthInput()
      const day = this._makeDayInput()
      const year = this._makeYearInput()

      inputsWrapper.appendChild(month)
      inputsWrapper.appendChild(day)
      inputsWrapper.appendChild(year)

      baseWrapper.appendChild(inputsWrapper)

      shadow.appendChild(link)
      shadow.appendChild(baseWrapper)

      this._monthSelect.addEventListener('change', (ev) => {
        this._handleChangeEv()
      })

      this._daySelect.addEventListener('change', () => {
        this._handleChangeEv()
      })

      this._yearSelect.addEventListener('change', () => {
        this._handleChangeEv()
      })

      this.addEventListener('CustomizationsReset', () => {
        this._reset()

        this.dispatchEvent(new CustomEvent('change', {
          value: this.value,
        }))
      })

      this.addEventListener('CustomizationsLoaded', (ev) => {
        this._reset()

        this.dispatchEvent(new CustomEvent('change', {
          value: this.value,
        }))
      })

      this.addEventListener('EmbellisherPreSubmit', () => {
        if (this.required && this.value === '') {
          baseWrapper.classList.add('bc-required-error')
        } else {
          baseWrapper.classList.remove('bc-required-error')
        }
      })
    }

    _maxDateTime() {
      const now = luxon.DateTime.now()

      return luxon.DateTime.utc(now.year + 10, 12, 31)
    }
  }

  class BNYTextInput extends HTMLElement {
    _shadow = undefined

    _restrictAlpha = false

    _restrictNumeric = false

    constructor() {
      super();

      this._shadow = this.attachShadow({ mode: 'open' })
    }

    static get observedAttributes() {
      return [
        'id',
        'label',
        'name',
        'required',
        'maxlength',
        'show-blank',
      ]
    }

    attributeChangedCallback(attr, oldVal, newVal) {

    }

    connectedCallback() {
      this.required = (this.getAttribute('required') !== null)
      this.value = ''

      const shadow = this._shadow;

      const link = document.createElement('link');
      link.rel = 'stylesheet'
      link.href = document.getElementById('customization-css').href

      const wrapper = document.createElement('div');
      wrapper.setAttribute('class', 'bc-element bc-textinput');

      if (this.required) {
        wrapper.classList.add('bc-required')
      }

      const inputId = 'bc-input-' + internalUniqueId;

      internalUniqueId++;

      const label = document.createElement('label');
      label.setAttribute('class', 'bc-label bc-label-textinput');
      label.setAttribute('for', inputId);

      const input = document.createElement('input');
      input.type = 'text'
      input.setAttribute('id', inputId);
      input.setAttribute('class', 'bc-input bc-input-text');

      if (this.hasAttribute('label')) {
        label.textContent = this.getAttribute('label');
      } else {
        label.textContent = 'Engraving';
      }

      let maxLen = 10
      if (this.getAttribute('maxlength') !== null) {
        maxLen = this.getAttribute('maxlength');
      }

      input.setAttribute('maxlength', String(maxLen));

      if (this.getAttribute('required') !== null) {
        input.required = true;
      }

      shadow.appendChild(link);
      shadow.appendChild(wrapper);

      wrapper.appendChild(label);
      wrapper.appendChild(input);

      if (this.hasAttribute('info')) {
        const info = document.createElement('span')
        info.setAttribute('class', 'bc-info bc-info-textinput')
        info.textContent = this.getAttribute('info')

        wrapper.appendChild(info)
      }

      if (this.hasAttribute('restrict-alpha')) {
        this._restrictAlpha = true
      }

      if (this.hasAttribute('restrict-numeric')) {
        this._restrictNumeric = true
      }

      shadow.addEventListener('keyup', (ev) => {
        if (this._restrictAlpha) {
          ev.target.value = ev.target.value.replace(/[^a-zA-Z0-9]+/g, '')
        }

        if (this._restrictNumeric) {
          ev.target.value = ev.target.value.replace(/[^0-9]+/g, '')
        }

        this.value = ev.target.value

        if (ev.target.value !== '' && wrapper.classList.contains('bc-required-error')) {
          wrapper.classList.remove('bc-required-error')
        }

        this.dispatchEvent(new CustomEvent('change', {
          value: ev.target.value,
        }));
      });

      this.addEventListener('CustomizationsReset', () => {
        this.value = ''
        input.value = ''
      })

      this.addEventListener('EmbellisherPreSubmit', () => {
        if (this.required && this.value === '') {
          wrapper.classList.add('bc-required-error')
        } else {
          wrapper.classList.remove('bc-required-error')
        }
      })
    }
  }

  class BNYFontPicker extends HTMLElement {
    static FontList = [
      'Script',
      'Modern',
      'Classic',
      'NellaSue',
      'Garamond',
      'Didot',
      'Great Vibes',
      'Merriweather',
    ]

    _shadow = undefined

    _fontInputs = []

    /**
     * By default we hide fonts that aren't in the font list. If we want to adjust this
     * behavior to instead disable them (keeping them visible but at a low opacity) we
     * instead can flip this to disable.
     *
     * The idea behind the disable mode is when we specify the 'usable-fonts' attribute
     * we can build a list of possible font choices, and by changing the 'fonts' attribute
     * enable/disable them depending on what a user does.
     *
     * @var {'hide' | 'disable'}
     */
    _fontVisbilityMode = 'hide'

    constructor() {
      super();

      this._shadow = this.attachShadow({ mode: 'open' })
    }

    static get observedAttributes() {
      return [
        'id',
        'label',
        'required',
        'fonts',
        'usable-fonts',
        'modal-fonts',
        'modal-styles',
      ]
    }

    attributeChangedCallback(attr, oldVal, newVal) {
      // console.log('BNYFontPicker attributeChanged', attr, 'oldVal=', typeof oldVal, oldVal, 'newVal=', typeof newVal, newVal)

      if (oldVal === newVal) {
        return
      }

      if (attr !== 'fonts') {
        return
      }

      const showFonts = newVal.split(',').map(v => v.trim()).filter(v => v !== '')

      let removedCheck = false

      const wrapClass = this._fontVisibilityClass()

      this._fontInputs.forEach(input => {
        const wrap = input.parentNode

        if (showFonts.includes(input.value)) {
          input.disabled = false

          if (wrap.classList.contains(wrapClass)) {
            wrap.classList.remove(wrapClass)
          }

        } else {
          if (input.checked) {
            removedCheck = true
            input.checked = false
          }

          input.disabled = true

          wrap.classList.add(wrapClass)
        }
      })

      // Due to the change in 'fonts' attribute we had to uncheck what the user
      // selected, so we're going to default to the first checked one and throw
      // a change event to reflect this
      if (removedCheck) {
        // Fall back to the first VISIBLE font (not FontList[0], which may be hidden
        // for the current tab) so the collected value always matches a highlighted button.
        const fallback = this._fontInputs.find(i => showFonts.includes(i.value)) || this._fontInputs[0]
        fallback.checked = true
        this.value = fallback.value
        this.dispatchEvent(new CustomEvent('change', {
          value: fallback.value,
        }))
      }
    }

    connectedCallback() {
      this.required = (this.getAttribute('required') !== null)

      // console.log('fontpicker ohgodwhatishappening Time')

      const shadow = this._shadow;

      const style = document.createElement('style')
      style.textContent = ''

      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = document.getElementById('customization-css').href

      const baseWrapper = document.createElement('div');
      baseWrapper.setAttribute('class', 'bc-element bc-element-font-picker');

      if (this.required) {
        baseWrapper.classList.add('bc-required')
      }

      const divLabel = document.createElement('div')
      divLabel.setAttribute('class', 'bc-label bc-label-fonts')

      if (this.getAttribute('label')) {
        divLabel.textContent = this.getAttribute('label')
      } else {
        divLabel.textContent = 'Font:'
      }

      const choiceWrapper = document.createElement('div')
      choiceWrapper.setAttribute('class', 'bc-elements bc-elements-choices bc-elements-fonts')

      baseWrapper.appendChild(divLabel)

      if (this.hasAttribute('modal-fonts')) {
        const modalBtn = document.createElement('button')
        modalBtn.type = 'button'
        modalBtn.textContent = 'Font Options'
        modalBtn.setAttribute('title', 'Show Font Preview')
        modalBtn.setAttribute('class', 'bc-btn bc-btn-font-preview')
        modalBtn.addEventListener('click', () => {
          this.dispatchEvent(new CustomEvent('openFontPreviewModal', {
            detail: {
              fonts: this.getAttribute('fonts'),
              styles: this.getAttribute('styles') || '',
            }
          }))
        })

        baseWrapper.appendChild(modalBtn)
      }

      baseWrapper.appendChild(choiceWrapper)

      // Establish our visibility ruling
      let fontVisibility = this.getAttribute('font-visibility')

      if (fontVisibility !== 'disable' && fontVisibility !== 'hide') {
        fontVisibility = 'hide'
      }

      this._fontVisbilityMode = fontVisibility

      // Let's get going with our default font list which is every possibility.
      let fonts = BNYFontPicker.FontList
      let showFonts = fonts

      // In order to let us change the 'fonts' attribute on the fly, we need a different
      // attribute to consider what are 'usable'
      if (this.getAttribute('usable-fonts') !== null) {
        fonts = this.getAttribute('usable-fonts').split(',').map(v => v.trim()).filter(v => v !== '')
      }

      if (this.getAttribute('fonts') !== null) {
        showFonts = this.getAttribute('fonts').split(',').map(v => v.trim()).filter(v => v !== '')
      }

      let defaultFont = showFonts.find(f => fonts.includes(f)) || fonts[0]

      if (fonts.includes(this.getAttribute('default'))) {
        defaultFont = this.getAttribute('default')
      }

      this.value = defaultFont

      const fontManager = new BNYFontManager()

      const wrapClass = this._fontVisibilityClass()

      fonts.forEach(fontName => {
        const included = showFonts.includes(fontName)

        const wrap = document.createElement('div')
        wrap.setAttribute('class', 'bc-element-choice bc-element-font-choice')

        if ( ! included) {
          wrap.classList.add(wrapClass)
        }

        const inputId = 'bc-input-' + internalUniqueId

        internalUniqueId++

        const input = document.createElement('input')
        input.id = inputId
        input.type = 'radio'
        input.name = 'font'
        input.value = fontName
        input.disabled = !included
        input.setAttribute('class', 'bc-input bc-input-choice bc-input-font-choice')

        if (fontName === defaultFont && included) {
          input.checked = true
        }

        this._fontInputs.push(input)

        const label = document.createElement('label')
        label.textContent = fontName
        label.setAttribute('for', inputId)
        label.setAttribute('class', 'bc-label bc-label-choice bc-label-font-choice bc-label-font--' + urlize(fontName))

        wrap.appendChild(input)
        wrap.appendChild(label)

        choiceWrapper.appendChild(wrap)

        // Regardless of whether or not the font is disabled, we should generate
        // the @font-face styling so we don't need the browser re-reading the stylesheet
        // whenever the 'fonts' attribute changes.
        style.textContent += fontManager.getFontFaceStyle(fontName)
      })

      // The styling must go to the document head as the previewer is in the standard
      // document root and not in a shadow root. If it were in a shadow root, we'd need
      // to build some hijinks to get this embedded into that shadow root and not include
      // it in this shadow root
      document.head.appendChild(style)

      shadow.appendChild(link)
      shadow.appendChild(baseWrapper)

      shadow.addEventListener('change', (ev) => {
        // console.log('BNYFont Change', ev);
        this.value = ev.target.value;

        // send the font to the collect, and apply the font class to the textbar
        // do a thing like "hey collector, attribute font = font" but vanilla javascript aaaaaaaaaaaaaaaaaaaa
        // it would be just crazy if it were as easy as something like $('.classname').attr('font', 'script')

        this.dispatchEvent(new CustomEvent('change', {
          value: ev.target.value,
        }));
      });

      this.addEventListener('CustomizationsLoaded', () => {
        this.dispatchEvent(new CustomEvent('change', {
          value: this.value,
        }))
      })

      this.addEventListener('CustomizationsReset', () => {
        this.value = defaultFont

        this._fontInputs.forEach(input => {
          // Ensure that we never check a disbaled input
          if (input.disabled) {
            input.checked = false
            return
          }

          if (input.value === defaultFont) {
            input.checked = true
          } else {
            input.checked = false
          }
        })
      })

      this.addEventListener('EmbellisherPreSubmit', () => {
        if (this.required && this.value === '') {
          baseWrapper.classList.add('bc-required-error')
        } else {
          baseWrapper.classList.remove('bc-required-error')
        }
      })
    }

    _fontVisibilityClass() {
      if (this._fontVisbilityMode === 'disable') {
        return 'bc-element-disabled'
      }

      return 'bc-element-hidden'
    }
  }

  class BNYPlaceHolder extends HTMLElement {
    _shadow = undefined

    _text = undefined

    constructor() {
      super()

      this._shadow = this.attachShadow({ mode: 'open' })
    }

    static get observedAttributes() {
      return ['message'];
    }

    attributeChangedCallback(attr, oldVal, newVal) {
      if (oldVal === newVal) {
        return
      }

      if (attr !== 'message') {
        return
      }

      if (this._text) {
        this._text.textContent = newVal
      }
    }

    connectedCallback() {
      if (!this._text) {
        this._text = document.createElement('div')
        this._text.classList.add('placeholder')

        const style = document.createElement('style')
        style.textContent = `.placeholder {
  background: #f5b2b2;
  color: #732222;
  font-size: 20px;
  text-align: center;
  padding: 10px;
}`

        this._shadow.appendChild(style)
        this._shadow.appendChild(this._text)
      }

      this._text.textContent = this.getAttribute('message') || 'No Message Defined'
    }
  }

  class BNYItemizedCollector extends HTMLElement {
    _input = undefined

    _selector = ''

    _product = undefined

    _mapping = undefined

    _sessionCache = undefined

    constructor() {
      super()

      // console.log('BNYItemizedCollector constructor called');
      this._sessionCache = new SessionCache()
      this._input = document.createElement('input')
      this._input.type = 'hidden'
      // console.log('Hidden input created:', this._input)
    }

    static get observedAttributes() {
      return []
    }

    attributeChangedCallback(attr, oldVal, newVal) {
      // console.log(`Attribute ${attr} changed from ${oldVal} to ${newVal}`);
    }

    stopCollecting(sel) {
      // console.log(`Stopping collection on selector: ${sel}`);
      document
        .querySelector(sel)
        .removeEventListener(this.onChangeCollector.bind(this))
    }

    startCollecting(sel) {
      // console.log(`Starting collection on selector: ${sel}`);
      document
        .querySelector(sel)
        .addEventListener('change', this.onChangeCollector.bind(this))
    }

    onChangeCollector() {
      // console.log('onChangeCollector triggered');
      const ele = document.querySelector(this._selector)
      // console.log('Element selected for collection:', ele);

      this.value = ele.value
      // console.log('Current input value:', this.value);

      if (this._mapping === null || typeof this._mapping === 'undefined') {
        this._input.disabled = true
        console.warn('BNYItemizedCollector mapping is null/undefined', this._mapping)
        return
      }

      if (ele.value === '') {
        this.value = ''
        this._input.value = ''
        this._input.disabled = true
        // console.log('Input is empty, disabling collector');
        return
      }

      let parentSku = Embellisher.ActiveVariant.sku;
      // console.log('Parent SKU:', parentSku);

      if ( ! parentSku) {
        // console.log('ActiveVariant', Embellisher.ActiveVariant)
        console.error('BNYItemizedCollector failed to find parent sku')
        return
      }

      let parentSkuMap = this._mapping[parentSku]
      // console.log('Parent SKU Map:', parentSkuMap);

      // Parent SKU Map isn't present by using the parent SKU, let's try and find the mapping via
      // regular expressions
      if ( ! parentSkuMap) {
        parentSkuMap = handleRegexMapping(parentSku, this._mapping)
      }

      if ( ! parentSkuMap) {
        console.error('Could not find SKU Mapping for SKU:', parentSku)
        return false
      }

      // Let's find the SKUs in the product data
      const variants = this._sessionCache.get('subProducts', this._product);
      // console.log('Variants fetched from session cache:', variants);

      switch (this.getAttribute('mode')) {
        case 'value-as-itemized-letters':
          this._handleValueAsItemizedLetters(variants, parentSkuMap, ele.value);
          break;
        default:
          this._handleValue(variants, parentSkuMap, ele.value);
          break;
      }
    }

    _handleValue(variants, parentSkuMap, value) {
      let childSku = parentSkuMap[value]

      if ( ! childSku) {
        this._input.disabled = true
        console.error('BNYItemizedCollector failed to map value "' + value + '" to map', this._mapping)
        return
      }

      childSku = childSku.toLowerCase()

      const variant = variants.find((v) => v.sku.toLowerCase() === childSku)

      if ( ! variant) {
        this._input.disabled = true
        console.error('BNYItemizedCollector failed to find variant with child sku "' + childSku + '"')
        return
      }

      // console.log('Using variant', variant)
      this._input.value = variant.id
      this._input.disabled = false
    }

    _handleValueAsItemizedLetters(variants, parentSkuMap, value) {
      // Handle multiple letters
      const letters = value.toUpperCase().split('');
      // console.log('Letters to be processed:', letters);
      let skus = [];

      letters.forEach((letter) => {
        const childSku = parentSkuMap[letter];
        // console.log(`Mapping letter "${letter}" to SKU:`, childSku);
        if ( ! childSku) {
          console.error(`BNYItemizedCollector failed to map letter "${letter}" to a SKU`, this._mapping);
          this._input.disabled = true;
          return;
        }

        skus.push(childSku.toLowerCase());
      });

      if (skus.length === 0) {
        this._input.disabled = true;
        // console.log('No SKUs found, disabling collector');
        return;
      }

      // console.log('SKUs to be checked in session cache:', skus);

      const variantIds = skus.map((sku) => {
        const variant = variants.find((v) => v.sku.toLowerCase() === sku);
        // console.log(`Finding variant for SKU "${sku}":`, variant);
        if ( ! variant) {
          console.error(`BNYItemizedCollector failed to find variant with SKU "${sku}"`);
          this._input.disabled = true;
          return null;
        }

        return variant.id;
      }).filter(v => v !== null);

      if (variantIds.length === 0) {
        this._input.disabled = true;
        // console.log('No valid variant IDs found, disabling collector');
        return
      }

      // console.log('Final variant IDs:', variantIds);

      // Concatenate variant IDs or adjust as needed
      this._input.value = variantIds.join(',');
      this._input.disabled = false;
      // console.log('Collector input value set to:', this._input.value);
    }

    connectedCallback() {
      // console.log('BNYItemizedCollector connectedCallback called');
      this.required = this.hasAttribute('required');
      this.value = '';

      const input = this._input;
      input.name = this.getAttribute('name');
      input.value = '';
      input.setAttribute('form', this.getAttribute('form'));
      // console.log('Collector input initialized:', input);

      this.appendChild(input)

      if (! this.hasAttribute('collect')) {
        console.error('Invalid BNYItemizedCollector setup: no collect')
        return
      }

      if ( ! this.hasAttribute('product') || ! this.hasAttribute('mapping')) {
        console.error('Invalid BNYItemizedCollector setup: no product and/or no mapping')
        return
      }

      this._product = this.getAttribute('product')
      // console.log('Collector product set to:', this._product);

      this._retrieveProductMapping()

      const selector = this.getAttribute('collect');
      this._selector = selector;
      // console.log('Collector selector set to:', this._selector);

      this.startCollecting(this._selector);
      // console.log('Collection started');
    }

    _retrieveProductMapping() {
      const mapValue = this.getAttribute('mapping');
      // console.log('Retrieving product mapping for:', mapValue);

      if (/^[a-zA-Z0-9_-]+$/.test(mapValue)) {
        const productMaps = Embellisher.Config.product_maps;
        // console.log('Product maps available:', productMaps);

        if (productMaps === null || typeof productMaps === 'undefined') {
          console.error('Need Product Map for key "' + mapValue + '" and no maps are defined.')
          return
        }

        const mapping = productMaps[ mapValue ]

        if (mapping === null || typeof mapping === 'undefined') {
          console.error('Could not find product map for mapValue "' + mapValue + '" in maps:', productMaps)
          return
        }

        this._mapping = mapping
        // console.log('Product mapping retrieved:', this._mapping);
      } else {
        this._mapping = JSON.parse(this.getAttribute('mapping'))
        // console.log('Mapping parsed from attribute:', this._mapping);
      }
    }
  }

  /*
    BNMMultiItemizedCollector Web Component
    - Listens for `charmPickerUpdate` events (dispatched by CoreCharmPicker)
    - Stores the selected variant IDs as a comma‑separated string in a hidden input
    - Exposes the input via the specified form/name attributes
  */
  class BNMMultiItemizedCollector extends HTMLElement {
    // Private field for the hidden input element
    #input;
    #pricedInput;

    constructor() {
      super();
      this.#input = document.createElement('input');
      this.#input.type = 'hidden';

      this.#pricedInput = document.createElement('input');
      this.#pricedInput.type = 'hidden';
    }

    connectedCallback() {
      // Initialize hidden input attributes from component attributes
      const name = this.getAttribute('name');
      const form = this.getAttribute('form');

      if (!name || !form) {
        console.warn('[BNMMultiItemizedCollector] Missing `name` or `form` attribute');
      }

      this.#input.name = name;
      this.#input.setAttribute('form', form);
      this.appendChild(this.#input);

      if (this.getAttribute('priced-name') !== 'false') {
        this.#pricedInput.name = 'addon[multi-charm-picker-priced]';
        this.#pricedInput.setAttribute('form', form);
        this.appendChild(this.#pricedInput);
      }

      // Listen for updates from CoreCharmPicker
      this._onCharmPickerUpdate = this._onCharmPickerUpdate.bind(this);
      window.addEventListener('charmPickerUpdate', this._onCharmPickerUpdate);
    }

    disconnectedCallback() {
      // Clean up listener when removed from DOM
      window.removeEventListener('charmPickerUpdate', this._onCharmPickerUpdate);
    }

    _onCharmPickerUpdate(e) {
      let expanded = [];

      if (Array.isArray(e.detail.selectedCharmVariantsExpanded) && e.detail.selectedCharmVariantsExpanded.length) {
        expanded = e.detail.selectedCharmVariantsExpanded
      } else if (Array.isArray(e.detail.selectedCharmVariants)) {
        expanded = e.detail.selectedCharmVariants
      }

      const pricedExpanded = Array.isArray(e.detail.pricedCharmVariantsExpanded)
        ? e.detail.pricedCharmVariantsExpanded
        : [];

      // If priced-only input is present, keep main input to non-priced items only
      let expandedForMain = expanded

      if (pricedExpanded) {
        const pricedSet = new Set(pricedExpanded)

        expandedForMain = expanded.filter((id) => !pricedSet.has(id))

        // Update priced-only input
        this.#pricedInput.value = pricedExpanded.join(',')
      }

      // Update the hidden input value
      this.#input.value = expandedForMain.join(',');

      // Notify any listeners of value change
      this.dispatchEvent(new Event('change', { bubbles: true }));

      console.log('[BNMMultiItemizedCollector] New selection (all):', this.#input.value);
      if (this.#pricedInput) {
        console.log('[BNMMultiItemizedCollector] Priced selection:', this.#pricedInput.value);
      }
    }
  }

  class BNYCollector extends HTMLElement {
    _input = undefined

    _selector = ''

    constructor() {
      super();

      this._input = document.createElement('input')
      this._input.type = 'hidden'
    }

    static get observedAttributes() {
      return [
        'name',
        'collect',
        'form',
        'required',
        'disabled',
      ]
    }

    attributeChangedCallback(attr, oldVal, newVal) {
      // console.log('BNYCollector', attr, oldVal, newVal)

      if (oldVal === newVal) {
        // console.log('SKIP')
        return
      }

      switch (attr) {
        case 'name':
          this._input.name = newVal
          break
        case 'collect':
          this._selector = newVal
          this.stopCollecting(oldVal)
          this.startCollecting(newVal)
          break
        case 'form':
          this._input.setAttribute('form', newVal)
          break
        case 'required':
          this._input.required = !!newVal
          break
        case 'disabled':
          this._input.disabled = typeof newVal === 'string'
          break
      }
    }

    stopCollecting(sel) {
      // console.log('stopCollecting', sel)

      const eles = document.querySelectorAll(sel)

      eles.forEach(ele => {
        ele.removeEventListener(this.onChangeCollector.bind(this))
      })
    }

    startCollecting(sel) {
      // console.log('startCollectin', sel)

      const eles = document.querySelectorAll(sel)

      eles.forEach(ele => {
        ele.addEventListener('change', this.onChangeCollector.bind(this))
      })
    }

    /**
     * When a collector changes we want to look through all the selectors its registered
     * to observe and build a valid list of values from them in the order they're in
     * the DOM. This allows us to collect and combine many values (i.e. from multiple
     * dropdowns) that can then be pushed into the Shopify Form
     */
    onChangeCollector() {
      // console.log('onChangeCollector', ev)
      const eles = document.querySelectorAll(this._selector)
      // console.log('change collector', eles)

      const values = []

      eles.forEach(ele => {
        if (ele.value !== undefined) {
          values.push(ele.value)
        }
      });

      // console.log('onChangeCollector end', values)
      this._input.value = values.join('')
      this.value = values.join('')

      if (this.value === '' && ! this.required) {
        this._input.disabled = true
      } else {
        this._input.disabled = false
      }
    }

    connectedCallback() {
      this.required = (this.getAttribute('required') !== null)
      this.value = ''

      const input = this._input

      input.name = this.getAttribute('name')
      input.value = ''
      input.setAttribute('form', this.getAttribute('form'))

      // We're not using the Shadow DOM for the collector since we need our input
      // element to be seen by the cart form
      this.appendChild(input)

      const selector = this.getAttribute('collect');

      if (selector !== null) {
        this._selector = selector
        this.startCollecting(selector)
      }
    }
  }

  class BPInitialPendant extends HTMLElement {
    _inner = undefined

    constructor() {
      super();
    }

    connectedCallback() {
      // console.log('BPInitialPendant connected')

      const inner = document.createElement('div')
      inner.setAttribute('class', 'bp-pendant-value')

      this.appendChild(inner)
      this._inner = inner

      const fromEle = document.getElementById(this.getAttribute('from'))

      fromEle.addEventListener('change', (ev) => {
        // console.log('fromEle CHANGE', ev, ev.value, ev.target.value)
        inner.textContent = ev.target.value
      });

      this._registerFontPicker(inner)
    }

    _registerFontPicker(inner) {
      if ( ! this.hasAttribute('font-picker') || this.getAttribute('font-picker') === '') {
        return
      }

      const pickerEle = document.getElementById(this.getAttribute('font-picker'))

      if ( ! pickerEle) {
        console.error('Could not find font picker element', this.getAttribute('font-picker'))
        return
      }

      pickerEle.addEventListener('change', (ev) => {
        inner.classList.forEach(className => {
          if (className.indexOf('bp-font') >= 0) {
            inner.classList.remove(className)
          }
        })

        inner.classList.add('bp-font-' + ev.target.value.toLowerCase())
      })
    }
  }

  class BPTextBar extends HTMLElement {
    _inner = undefined

    constructor() {
      super();
    }

    connectedCallback() {
      const inner = document.createElement('div')
      inner.setAttribute('class', 'bp-textbar')

      this.appendChild(inner)
      this._inner = inner

      const fromEle = document.getElementById(this.getAttribute('from'))

      fromEle.addEventListener('change', (ev) => {
        // console.log('fromEle CHANGE', ev, ev.value, ev.target.value)
        inner.textContent = ev.target.value
      });

      this._registerFontPicker(inner)
    }

    _registerFontPicker(inner) {
      if ( ! this.hasAttribute('font-picker') || this.getAttribute('font-picker') === '') {
        return
      }

      const pickerEle = document.getElementById(this.getAttribute('font-picker'))

      if ( ! pickerEle) {
        console.error('Could not find font picker element', this.getAttribute('font-picker'))
        return
      }

      pickerEle.addEventListener('change', (ev) => {
        inner.classList.forEach(className => {
          if (className.indexOf('bp-font') >= 0) {
            inner.classList.remove(className)
          }
        })

        inner.classList.add('bp-font-' + urlize(ev.target.value.toLowerCase()))
      })
    }
  }

  class BPOrnament extends HTMLElement {
    _inner = undefined

    _queries = []

    constructor() {
      super()
    }

    connectedCallback() {
      this._inner = document.createElement('div')
      this._inner.setAttribute('class', 'bp-ornament')

      this.appendChild(this._inner)

      this._queries = this.getAttribute('collect').split(',').map(v => v.trim()).filter(v => v !== '')

      // console.log('this._queries', this._queries)

      this._queries.forEach(query => {
        const ele = document.querySelector(query)

        // console.log('query', query, ele)

        if (ele) {
          // console.log('query ele', ele)
          ele.addEventListener('change', () => {
            // console.log('ele addEventListener change')
            this._onChangeEv()
          })
        }
      })
    }

    _onChangeEv() {
      // console.log('onChangeEv')

      const values = []

      this._queries.forEach(query => {
        const ele = document.querySelector(query)

        // console.log('onChangeEv ele', ele, ele.value)

        if (ele) {
          values.push(ele.value)
        }
      })

      const output = values.join('\n')
      const lines = output.split('\n')

      const expected = [
        lines[0] || '',
        lines[1] || '',
        lines[2] || '',
      ].join('\n')

      this._inner.textContent = expected
      this._inner.innerHTML = this._inner.textContent.replace(/\n/g, '<br>\n')
    }

  }

  class BPNameplate extends HTMLElement {
    _inner = undefined

    constructor() {
      super()
    }

    connectedCallback() {
      const inner = document.createElement('div')
      inner.setAttribute('class', 'bp-nameplate')

      this.appendChild(inner)
      this._inner = inner

      const fromEle = document.getElementById(this.getAttribute('from'))

      fromEle.addEventListener('change', (ev) => {
        inner.textContent = ev.target.value.toLowerCase()
      })

      if (this.hasAttribute('font-picker')) {
        const pickerEle = document.getElementById(this.getAttribute('font-picker'))

        if (pickerEle) {
          pickerEle.addEventListener('change', (ev) => {
            inner.classList.forEach(className => {
              if (className.indexOf('bp-font') >= 0) {
                inner.classList.remove(className)
              }
            })

            inner.classList.add('bp-font-' + ev.target.value.toLowerCase())
          })
        }
      }

      this.addEventListener('CustomizationsReset', () => {
        inner.textContent = ''
      })
    }
  }

  class BPWillowPendant extends HTMLElement {
    _inner = undefined
    _outer = undefined

    constructor() {
      super();
    }

    _registerMonogramFont() {
      let qry = document.getElementById('willow-monogram-font-style');

      if (qry) {
        return;
      }

      const fontMgr = new BNYFontManager();

      const style = document.createElement('style');
      style.id = 'willow-monogram-font-style';
      style.textContent = fontMgr.fontMonogram();

      document.body.appendChild(style);
    }

    connectedCallback() {
      this._registerMonogramFont()

      const outer = document.createElement('div')
      outer.setAttribute('class', 'bp-pendant-value')

      this.appendChild(outer)
      this._outer = outer

      for(let n=0; n<3; n++) {

        const inner = document.createElement('div')
        inner.setAttribute('class', 'bp-pendant-value'+n)

        outer.appendChild(inner)
        this._inner = inner

        const fromEle = document.getElementById(this.getAttribute('from'))

        fromEle.addEventListener('change', (ev) => {
          inner.textContent = ev.target.value[n];

          inner.setAttribute('data-letter', 'bc-dropdown-'+inner.textContent);
        });

        this._registerFontPicker(inner)
      }

    }

    _registerFontPicker(inner) {
      if ( ! this.hasAttribute('font-picker') || this.getAttribute('font-picker') === '') {
        return
      }

      const pickerEle = document.getElementById(this.getAttribute('font-picker'))

      if ( ! pickerEle) {
        console.error('Could not find font picker element', this.getAttribute('font-picker'))
        return
      }

      pickerEle.addEventListener('change', (ev) => {
        inner.classList.forEach(className => {
          if (className.indexOf('bp-font') >= 0) {
            inner.classList.remove(className)
          }
        })

        inner.classList.add('bp-font-' + ev.target.value.toLowerCase())
      })
    }
  }

  class BPCustomInitialOrMonogramRound extends HTMLElement {
    _inner = undefined
    _outer = undefined

    constructor() {
      super();
    }

    _registerMonogramFont() {
      let qry = document.getElementById('willow-monogram-font-style');

      if (qry) {
        return;
      }

      const fontMgr = new BNYFontManager();

      const style = document.createElement('style');
      style.id = 'willow-monogram-font-style';
      style.textContent = fontMgr.fontMonogram();

      document.body.appendChild(style);
    }

    connectedCallback() {
      this._registerMonogramFont()

      const outer = document.createElement('div')
      outer.setAttribute('class', 'bp-pendant-value')

      this.appendChild(outer)
      this._outer = outer

      for(let n=0; n<3; n++) {

        const inner = document.createElement('div')
        inner.setAttribute('class', 'bp-pendant-value'+n)

        outer.appendChild(inner)
        this._inner = inner

        const fromEle = document.getElementById(this.getAttribute('from'))

        fromEle.addEventListener('change', (ev) => {
          inner.textContent = ev.target.value[n];

          inner.setAttribute('data-letter', 'bc-dropdown-'+inner.textContent);
        });

        this._registerFontPicker(inner)
      }

    }

    _registerFontPicker(inner) {
      if ( ! this.hasAttribute('font-picker') || this.getAttribute('font-picker') === '') {
        return
      }

      const pickerEle = document.getElementById(this.getAttribute('font-picker'))

      if ( ! pickerEle) {
        console.error('Could not find font picker element', this.getAttribute('font-picker'))
        return
      }

      pickerEle.addEventListener('change', (ev) => {
        inner.classList.forEach(className => {
          if (className.indexOf('bp-font') >= 0) {
            inner.classList.remove(className)
          }
        })

        inner.classList.add('bp-font-' + ev.target.value.toLowerCase())
      })
    }
  }

  class BPBirthstone extends HTMLElement {
    _inner = undefined

    constructor() {
      super();
    }

    connectedCallback() {
      // console.log('BPInitialPendant connected')

      const inner = document.createElement('div')
      inner.setAttribute('class', 'bp-pendant-value')

      this.appendChild(inner)
      this._inner = inner

      const fromEle = document.getElementById(this.getAttribute('from'))

      fromEle.addEventListener('change', (ev) => {
        // console.log('fromEle CHANGE', ev, ev.value, ev.target.value)
        const months = ["birthstone-Jan","birthstone-Feb","birthstone-Mar","birthstone-Apr","birthstone-May","birthstone-Jun","birthstone-Jul","birthstone-Aug","birthstone-Sep","birthstone-Oct","birthstone-Nov","birthstone-Dec"];
        this.classList.remove(...months);
        this.classList.add("birthstone-" + ev.target.value);
      });

      this._registerFontPicker(inner)
    }

    _registerFontPicker(inner) {
      if ( ! this.hasAttribute('font-picker') || this.getAttribute('font-picker') === '') {
        return
      }

      const pickerEle = document.getElementById(this.getAttribute('font-picker'))

      if ( ! pickerEle) {
        console.error('Could not find font picker element', this.getAttribute('font-picker'))
        return
      }

      pickerEle.addEventListener('change', (ev) => {
        inner.classList.forEach(className => {
          if (className.indexOf('bp-font') >= 0) {
            inner.classList.remove(className)
          }
        })

        inner.classList.add('bp-font-' + ev.target.value.toLowerCase())
      })
    }
  }

  /*
    CoreCharmPicker Web Component
    - Fetches specific metaobject entries by handle via Storefront API
    - Extracts titles and product_list fields from those entries
    - Fetches each product’s variants via Storefront API
    - Renders entry headings and parent-product buttons
    - Manages selection of up to `maxCharms` variants (allowing duplicates)
    - Uses fixed placeholder layout in preview to avoid shifting
    - Dispatches `charmPickerUpdate` events on selection changes
  */
  class CoreCharmPicker extends HTMLElement {
    _shadow;
    _accessToken;
    _selectedVariants = [];
    _maxCharms = 1;
    _currentAddPrice = false;
    _priceSummaryEl;
    _pricedVariantIds = {};
    _variantPrices = {};

    constructor() {
      super();
      this._accessToken = theme.settings.storefrontApiKey;
      this._shadow = this.attachShadow({ mode: 'open' });
    }

    get value() {
      const max = this._maxCharms;
      if (this.required && this._selectedVariants.length !== max) {
        this._warn(`Returning empty: selected ${this._selectedVariants.length}, required ${max}`);
        return '';
      }
      const m = parseInt(this.getAttribute('multiplier')) || 1
      const out = []
      for (let i = 0; i < this._selectedVariants.length; i++) {
        for (let k = 0; k < m; k++) { out.push(this._selectedVariants[i]) }
      }
      return out.join(',');
    }

    get hasError() {
      return this.required && this._selectedVariants.length !== this._maxCharms;
    }

    _getMaxCharms() {
      const variantQtyMap = Embellisher.Config.variant_quantity_map;

      if (!variantQtyMap) {
        this._error('no count variant qty mapping found');
        return;
      }

      const mapIdToUse = this.getAttribute('use-map-id');
      const mapToUse = variantQtyMap.variants?.find(v => v.map_id === mapIdToUse);

      if (!mapToUse) {
        this._error('could not find map to use "' + mapIdToUse + '"', mapIdToUse);
        return;
      }

      const qtyName = mapToUse.quantity_selector;

      let optionKey;

      Object.keys(Embellisher.VariantOptionMap).forEach(key => {
        const name = Embellisher.VariantOptionMap[key];

        if (name.trim() === qtyName.trim()) {
          optionKey = key;
        }
      })

      if (!optionKey) {
        this._error('Could not find qty selector', qtyName, 'in variant option map', Embellisher.VariantOptionMap);
        return;
      }

      const optionVal = parseInt(Embellisher.ActiveVariant[optionKey]);

      if (isNaN(optionVal)) {
        this._error('Could not find option key', optionKey, 'and got a bad value', optionVal);
        return;
      }

      return optionVal;
    }

    _updateAddToCartState() {
      requestAnimationFrame(() => {
        const btn = document.querySelector('.personalize-add-to-cart');
        if (!btn) { return; }
        // Only enable “Add to cart” once the exact number is picked
        btn.disabled = this._selectedVariants.length !== this._maxCharms;
      });
    }

    async connectedCallback() {
      // 0) get max charms
      this._maxCharms = this._getMaxCharms();

      // 1) Make sure the sticky preview bar is visible
      const stickyPreview = document.querySelector('.bc-sticky-preview-wrapper');
      if (stickyPreview) {
        stickyPreview.style.display = 'flex';
      }

      // 2) Pull CSS into the shadow root
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = document.getElementById('customization-css')?.href;
      this._shadow.append(link);

      // 3) Build container structure
      const wrapper = this._makeContainer('bc-element bc-charm-picker');
      wrapper.id = 'charm-picker-wrapper';
      this.required = this.hasAttribute('required');

      const selectionInfo = document.createElement('label');
      selectionInfo.className = 'bc-selection-info';
      selectionInfo.textContent = `*Select your charm count on the previous screen.`;

      const categoryLabel = document.createElement('label');
      categoryLabel.className = 'bc-label bc-charm-style';
      categoryLabel.textContent = `Select Charm Styles:`;

      const charmSelectionInfo = document.createElement('label');
      charmSelectionInfo.className = 'bc-selection-info';
      charmSelectionInfo.textContent = `*You can add more than one! (For Eligable Charm Counts.)`;

      const componentLabel = document.createElement('label');
      componentLabel.className = 'bc-label component_label';
      componentLabel.textContent = `Select Charms:`;

      const charmContainer   = this._makeContainer('bc-charm-container');

      const charmScroll   = document.createElement('div');
      charmScroll.className = 'bc-scroll-info';

      const variantContainer = this._makeContainer('bc-variant-container but-whole');
      wrapper.append(selectionInfo, categoryLabel, charmContainer, charmScroll, componentLabel, charmSelectionInfo, variantContainer);
      this._shadow.append(wrapper);

      // price summary label (inserted just before variantContainer)
      const priceSummary = document.createElement('label');
      priceSummary.className = 'bc-selection-info charm-price-summary';
      priceSummary.textContent = '';
      this._priceSummaryEl = priceSummary;
      wrapper.insertBefore(priceSummary, variantContainer);

      // 4) Kick off the data fetch -> render parent buttons -> render variants on click
      const defHandle  = this.getAttribute('type');
      const entriesRaw = this.getAttribute('entries');

      let entriesMap;

      try {
        entriesMap = JSON.parse(entriesRaw);
      } catch (e) {
        this._error('Invalid entries JSON', entriesRaw);
        entriesMap = {};
      }

      // console.log('[CoreCharmPicker][entries] raw attr:', entriesRaw)
      // console.log('[CoreCharmPicker][entries] parsed keys:', Object.keys(entriesMap))

      const sectionConfigs = Object.entries(entriesMap).map(([title, val]) => {
        let handles = []
        let addPrice = false

        if (Array.isArray(val)) {
          handles = val
        } else if (val && Array.isArray(val.handles)) {
          handles = val.handles
        }

        if (val && val.add_price) {
          addPrice = true
        }

        return { title, handles, addPrice }
      })

      console.log(
        '[CoreCharmPicker][entries] sectionConfigs (JSON order):',
        sectionConfigs
      )

      // fetch all sections in parallel, then render buttons in one pass
      const fetched = await Promise.all(
        sectionConfigs.map(async ({ title, handles, addPrice }) => {
          console.log('[CoreCharmPicker][btn] start fetch:', title)
          try {
            const entries = await this._fetchEntriesWithTitles(defHandle, handles)
            const productIds = entries.flatMap(e => e.product_ids)
            const variantIds = entries.flatMap(e => e.variant_ids)
            return { title, productIds, variantIds, addPrice }
          } catch (err) {
            this._error('Fetch entries failed for section', title, err)
            return { title, productIds: [], variantIds: [], addPrice }
          }
        })
      )

      let index = 0
      fetched.forEach(({ title, productIds, variantIds, addPrice }) => {
        index++
        console.log('[CoreCharmPicker][btn] renderSectionButton:', title, 'idx:', index, 'addPrice:', addPrice)
        this._renderSectionButton(charmContainer, title, productIds, variantIds, index, addPrice)
      })

      // 5) Events: reset only on CustomizationsReset
      this.addEventListener('CustomizationsReset', () => this._reset())

      // On CustomizationsLoaded, ensure our region exists and has placeholders; do NOT clear others
      this.addEventListener('CustomizationsLoaded', () => {
        const region = this._getPreviewRegion()
        if (!region) { return }
        if (region.children.length === 0) { this._renderPreviewPlaceholders() }
      })

      // 6) Draw the empty placeholders in the preview area (scoped to our region)
      this._renderPreviewPlaceholders();
    }

    _reset() {
      this._selectedVariants = [];
      this._pricedVariantIds = {};
      this._variantPrices = {};
      this._shadow.querySelector('#charm-picker-wrapper')?.classList.remove('bc-required-error');
      this._renderPreviewPlaceholders();
      this._updateAddToCartState();
      this._priceSummaryEl.textContent = '';
    }

    _getPreviewRegion() {
      const root = document.getElementById('bny-customizations-live-preview');
      if (!root) { return null }

      const regionName = this.getAttribute('preview-region') || 'charms';
      let region = root.querySelector(`[data-preview-region="${regionName}"]`);

      if (!region) {
        region = document.createElement('div');
        region.dataset.previewRegion = regionName;
        region.className = 'charm-preview-region';
        root.append(region);
      }

      return region;
    }

    _renderPreviewPlaceholders() {
      const max = this._maxCharms;

      const region = this._getPreviewRegion();
      if (!region) { return; }

      region.innerHTML = '';

      for (let i = 0; i < max; i++) {
        const slot = document.createElement('div');
        slot.className = 'charm-selected-container charm-placeholder';
        slot.dataset.index = i;

        const img = document.createElement('img');
        img.src = 'https://placehold.co/48x75?text=?';
        img.alt = 'Empty Charm Slot';
        img.className = 'charm-selected-img charm-placeholder-img';
        slot.append(img);

        region.append(slot);
      }
    }

    _makeContainer(classes) {
      const div = document.createElement('div');
      classes.split(' ').forEach(c => div.classList.add(c));
      return div;
    }

    async _fetchGraphQL(query, vars = {}) {
      const res = await fetch('/api/2025-04/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': this._accessToken,
        },
        body: JSON.stringify({ query, variables: vars })
      });

      if (!res.ok) {
        const text = await res.text();
        this._error(`GraphQL fetch failed: ${res.status}`, text);
        throw new Error(`GraphQL ${res.status}`);
      }

      const json = await res.json();

      if (json.errors) {
        this._error('GraphQL returned errors:', json.errors);
      }

      return json.data;
    }

    /**
     * Fetch each entry by handle/type, extract `charm_title` and `product_list` field
     * returns array of { handle, title, ids }
     */
    async _fetchEntriesWithTitles(defHandle, entryHandles) {
      const entries = [];
      const q = `
        query($input: MetaobjectHandleInput!) {
          metaobject(handle: $input) {
            fields {
              key
              value
            }
          }
        }
      `;

      await Promise.all(entryHandles.map(handle =>
        this._fetchGraphQL(q, { input: { handle, type: defHandle } })
          .then(data => {
            const meta = data.metaobject;
            if (!meta) {
              console.warn('[CoreCharmPicker] no metaobject for', handle);
              return;
            }

            // product ids
            let listField = meta.fields.find(f => f.key === 'product_list' || f.key === 'charmpicker');
            const productIds = [];
            if (listField) {
              try { JSON.parse(listField.value).forEach(gid => productIds.push(gid)); }
              catch (e) { console.error('[CoreCharmPicker] invalid JSON in', listField.key); }
            }

            // variant ids
            listField = meta.fields.find(f => f.key === 'variant_list');
            const variantIds = [];
            if (listField) {
              try { JSON.parse(listField.value).forEach(gid => variantIds.push(gid)); }
              catch (e) { console.error('[CoreCharmPicker] invalid JSON in', listField.key); }
            }

            entries.push({ handle, product_ids: productIds, variant_ids: variantIds });
          })
          .catch(err => console.error('[CoreCharmPicker] fetchEntries error for', handle, err))
      ));

      return entries;
    }

    async _fetchNodes(ids) {
      const q = `
        query($ids: [ID!]!) {
          nodes(ids:$ids) {
            ... on Product {
              id
              title
              image {
                url
              }
              availableForSale
            }
          }
        }
      `;

      const data = await this._fetchGraphQL(q, { ids });

      return data.nodes.reduce((map, n) => { if (n) map[n.id] = n; return map; }, {});
    }

    /**
     *
     * @param {HTMLElement} container
     * @param {string} sectionTitle
     * @param {string[]} productIds
     * @param {string[]} variantIds
     * @param {number} index
     * @param {boolean} addPrice
     */
    async _renderSectionButton(container, sectionTitle, productIds, variantIds, index, addPrice) {
      const btn = document.createElement('button');
      btn.className = 'bc-product-button';
      btn.textContent = sectionTitle;

      btn.addEventListener('click', async () => {
        this._currentAddPrice = addPrice;

        // deselect all and highlight this section
        this._shadow.querySelectorAll('.bc-product-button')
          .forEach(b => b.classList.remove('selected'))

        btn.classList.add('selected')

        // clear variant container once
        const variantContainer = this._shadow.querySelector('.bc-variant-container');
        variantContainer.innerHTML = '';

        await this._displayProductIds(productIds);
        await this._displayVariants(variantIds);
      });

      container.append(btn);

      // Initialize with the first option selected and show its variants
      if (index === 1) {
        btn.classList.add('selected');

        await this._displayProductIds(productIds);
        await this._displayVariants(variantIds);
      }
    }

    async _displayVariants(variantIds) {
      // this._log('Loading variant id', variantId);
      const q = `
        query getVariantWithAltName($ids: [ID!]!) {
          nodes(ids: $ids) {
            ... on ProductVariant {
              id
              title
              image {
                url
              }

              availableForSale
              altVariantName: metafield(namespace: "custom", key: "alt_variant_name") {
                value
                type
              }
              price {
                amount
                currencyCode
              }
            }
          }
        }
      `;

      const data = await this._fetchGraphQL(q, { ids: variantIds });
      const nodes = (data?.nodes || []).filter(Boolean);

      // enforce the exact order passed in via variantIds
      nodes.sort((a, b) => variantIds.indexOf(a.id) - variantIds.indexOf(b.id));

      const variantContainer = this._shadow.querySelector('.bc-variant-container');
      for (let i = 0; i < nodes.length; i++) {
        const productVariant = nodes[i];
        if (!productVariant) { return this._error('No Product Variant Found'); }

        const btn = this._renderVariantButton(productVariant);
        variantContainer.append(btn);
      }
    }

    async _displayProductIds(productIds) {
      const q = `
        query getProductsVariants($ids: [ID!]!) {
          nodes(ids: $ids) {
            ... on Product {
              id

              variants(first: 50) {
                nodes {
                  id
                  title
                  image { url }
                  availableForSale
                  altVariantName: metafield(namespace: "custom", key: "alt_variant_name") {
                    value
                    type
                  }
                  price {
                    amount
                    currencyCode
                  }
                }
              }
            }
          }
        }
      `

      const data = await this._fetchGraphQL(q, { ids: productIds });

      if ( ! data || ! data.nodes) {
        return this._error('graphql broke');
      }

      const variantContainer = this._shadow.querySelector('.bc-variant-container');

      productIds.forEach(productId => {
        const productNode = data.nodes.find(x => x.id === productId)

        // couldn't find it oh well
        if ( ! productNode) {
          return;
        }

        productNode.variants.nodes.forEach(variantNode => {
          const btn = this._renderVariantButton(variantNode);
          variantContainer.append(btn);
        });
      });

      this._updateAddToCartState();
    }

    async _displayProductVariants(productId) {
      const q = `
        query getVariantsWithAltName($id: ID!) {
          product(id: $id) {
            variants(first: 50) {
              edges {
                node {
                  id
                  title
                  image { url }
                  availableForSale
                  altVariantName: metafield(namespace: "custom", key: "alt_variant_name") {
                    value
                    type
                  }
                  price {
                    amount
                    currencyCode
                  }
                }
              }
            }
          }
        }
      `;

      const data = await this._fetchGraphQL(q, { id: productId });
      // Guard against missing data or null response
      if (!data || !data.product) {
        return this._error('No product');
      }

      const product = data.product;

      const variantContainer = this._shadow.querySelector('.bc-variant-container');

      product.variants.edges.forEach(({ node }) => {
        const btn = this._renderVariantButton(node);
        variantContainer.append(btn);
      });

      this._updateAddToCartState();
    }

    _addVariant(id, imageUrl, title) {
      const max = this._maxCharms;

      if (this._selectedVariants.length >= max) {
        return;
      }

      this._selectedVariants.push(id);

      const region = this._getPreviewRegion();
      if (!region) {
        return;
      }

      // 1) Find the next empty preview slot
      const nextSlot = [ ...region.children ].find(slot => slot.classList.contains('charm-placeholder'));
      if (!nextSlot) {
        return;
      }

      // 2) Build the filled slot (image + remove link)
      const content = document.createElement('div');
      content.className = 'charm-selected-container';
      content.dataset.variantId = id;

      const img = document.createElement('img');
      img.src = imageUrl;
      img.alt = title;
      img.className = 'charm-selected-img';
      img.style.cursor = 'pointer';
      content.append(img);

      const removeLink = document.createElement('span');
      removeLink.className = 'charm-remove-link';
      removeLink.textContent = 'Remove';
      removeLink.style.display = 'block';
      content.append(removeLink);

      // 3) Wire up removal
      const removeHandler = (e) => {
        e.stopPropagation();

        const idx = this._selectedVariants.indexOf(id);
        if (idx > -1) {
          this._selectedVariants.splice(idx, 1);
        }

        region.replaceChild(nextSlot.cloneNode(true), content);
        this._updateBadgesAndState(id);
      };

      // 4) Wire it to both the link and the image
      removeLink.addEventListener('click', removeHandler);
      img.addEventListener('click', removeHandler);

      region.replaceChild(content, nextSlot);
      this._updateBadgesAndState(id);
    }

    _getIntId(gid) {
      // it's already done so we're good
      if (typeof gid === 'number') {
        return gid;
      }

      // assume we're good since it's a string without a slash
      if (!gid.includes('/')) {
        return gid;
      }

      // pop returns the last bit of a split, so we just split freely.
      return gid.split('/').pop();
    }

    _renderVariantButton(node) {
      const rawId = this._getIntId(node.id);
      const count = this._selectedVariants.filter(i => i === rawId).length;
      const btn = document.createElement('button');
      btn.className = 'bc-variant-button';

      if (!node.availableForSale) {
        btn.disabled = true;
        btn.classList.add('bc-element-disabled');
      }

      if (count) {
        btn.classList.add('selected');
      }

      let isValidPrice = false

      if (node.price && node.price.amount) {
        isValidPrice = true
      }

      const wrapper = this._makeContainer('bc-variant-img-wrapper');
      wrapper.dataset.variantId = rawId;
      wrapper.dataset.addPrice = this._currentAddPrice ? 'true' : 'false';
      wrapper.dataset.price = isValidPrice ? String(node.price.amount) : '0';

      if (this._currentAddPrice && isValidPrice) {
        this._pricedVariantIds[rawId] = true;
        this._variantPrices[rawId] = parseFloat(node.price.amount);
      }

      const img = document.createElement('img');
      img.src = this._getNodeImage(node);

      if (node.altVariantName?.value) {
        img.alt = node.altVariantName?.value;
      } else {
        img.alt = node.title;
      }

      img.className = 'bc-variant-img';
      wrapper.append(img);

      const label = document.createElement('span');
      label.className = 'bc-variant-label';

      if (node.altVariantName?.value) {
        label.textContent = node.altVariantName?.value; // This is the Variant Title override from variant level metafields
      } else {
        label.textContent = node.title; // This is the Variant Title default
      }

      wrapper.append(label);

      if (this._currentAddPrice && isValidPrice) {
        const priceLabel = document.createElement('span');
        priceLabel.className = 'bc-variant-price';
        priceLabel.innerHTML = '+ $' + theme.Currency.formatMoney(node.price.amount * 100);

        wrapper.append(priceLabel);
      }

      const badge = document.createElement('span');
      badge.className = 'bc-quantity-badge';
      badge.dataset.variantId = rawId;
      badge.textContent = count;
      badge.style.display = count ? 'flex' : 'none';
      wrapper.append(badge);

      btn.append(wrapper);
      btn.addEventListener('click', () => {
        // this._log('Variant button clicked:', rawId);
        this._addVariant(rawId, this._getNodeImage(node), node.title);
      });

      return btn;  // ← ensure we return the <button> element
    }

    _getNodeImage(node, purpose) {
      if (!node.image?.url) {
        return `https://placehold.co/48x75?text=${ encodeURIComponent(node.title) }`
      }

      let suffix = '';

      switch (purpose) {
        case 'selected':
          suffix = 'width=250&height=200&crop=top';
          break;
        default:
        case 'grid':
          suffix = 'width=150&height=150&crop=center&quality=80';
          break;
      }

      let imageUrl = node.image.url;

      // Shopify URL's often already have a query string,
      // so we're going to go ahead and double check here.
      if (imageUrl.includes('?')) {
        imageUrl += '&' + suffix;
      } else {
        imageUrl += '?' + suffix;
      }

      return imageUrl;
    }

    _updateBadgesAndState(id) {
      const badge = this._shadow.querySelector(`.bc-quantity-badge[data-variant-id="${id}"]`);
      const count = this._selectedVariants.filter(i => i === id).length;
      if (badge) {
        badge.textContent = count;
        badge.style.display = count ? 'flex' : 'none';
      }

      const btn = this._shadow.querySelector(`.bc-variant-img-wrapper[data-variant-id="${id}"]`)?.closest('button');

      if (btn) {
        if (count) {
          btn.classList.add('selected');
        } else {
          btn.classList.remove('selected');
        }
      }

      this._updateAddToCartState();
      // this._log('Dispatching charmPickerUpdate event with:', this._selectedVariants);

      const m = parseInt(this.getAttribute('multiplier')) || 1
      const expanded = []

      for (let i = 0; i < this._selectedVariants.length; i++) {
        for (let k = 0; k < m; k++) {
          expanded.push(this._selectedVariants[i])
        }
      }

      // build a separate expanded list of "priced" charms, based on our internal map
      const pricedExpanded = []
      for (let i = 0; i < this._selectedVariants.length; i++) {
        //console.log('selected', i);
        const vid = this._selectedVariants[i]
        if (!this._pricedVariantIds[vid]) continue
        for (let k = 0; k < m; k++) {
          //console.log('WHAT', k, ' IS THIS ', i);
          pricedExpanded.push(vid)
        }
      }

      // compute total additional cost using internal price map
      let total = 0
      for (let i = 0; i < this._selectedVariants.length; i++) {
        const vid = this._selectedVariants[i]

        if (!this._pricedVariantIds[vid] || isNaN(this._pricedVariantIds[vid])) {
          continue
        }

        total += this._variantPrices[vid] * m
      }

      this._priceSummaryEl.textContent = ''
      if (total > 0) {
        this._priceSummaryEl.textContent = `Additional charm cost: $${ total.toFixed(2) }`
      }

      window.dispatchEvent(new CustomEvent('charmPickerUpdate', {
        detail: {
          selectedCharmVariants: this._selectedVariants,
          selectedCharmVariantsExpanded: expanded,
          pricedCharmVariantsExpanded: pricedExpanded,
        },
      }));
    }

    _log(...args) { console.log('[CoreCharmPicker]', ...args); }
    _warn(...args) { console.warn('[CoreCharmPicker]', ...args); }
    _error(...args) { console.error('[CoreCharmPicker]', ...args); }
  }

  //form elements
  customElements.define('bny-placeholder', BNYPlaceHolder);
  customElements.define('bny-coordinate', BNYCoordinate);
  customElements.define('bny-dropdown', BNYDropDown);
  customElements.define('core-charm-picker', CoreCharmPicker);
  customElements.define('bny-radio-birthstone', BNYRadioBirthstone);
  customElements.define('bny-dropdown-itemized', BNYDropdownItemized);
  customElements.define('bny-text-input-with-inventory', BNYTextInputWithInventory);
  customElements.define('bny-radio-zodiac', BNYRadioZodiac);
  customElements.define('bny-textdate', BNYTextDate);
  customElements.define('bny-textinput', BNYTextInput);
  customElements.define('bny-fontpicker', BNYFontPicker);
  customElements.define('bny-monogram-tabs', BNYMonogramTabs);
  customElements.define('core-engraving-tabs', CoreEngravingTabs);
  customElements.define('bny-multi-itemized-collector', BNMMultiItemizedCollector);
  customElements.define('bny-itemized-collector', BNYItemizedCollector);
  customElements.define('bny-collector', BNYCollector);


  //previewer elements
  customElements.define('bp-initial-pendant', BPInitialPendant);
  customElements.define('bp-textbar', BPTextBar);
  customElements.define('bp-ornament', BPOrnament);
  customElements.define('bp-nameplate', BPNameplate);
  customElements.define('bp-willow-pendant', BPWillowPendant);
  customElements.define('bp-birthstone', BPBirthstone);
  customElements.define('bp-custom-initial-or-monogram-round', BPCustomInitialOrMonogramRound);
}());

(function () {
  let main

  function moveElementToMainContent(id) {
    if (!main) {
      main = document.getElementById('MainContent')
    }

    const ele = document.getElementById(id)

    if (!ele) {
      return
    }

    ele.parentNode.removeChild(ele)
    main.appendChild(ele)
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Move CustomizatonDrawer to the main content area --
    // fixes issues with z-index stuff and the sidebar being sticky
    moveElementToMainContent('CustomizationDrawer')

    const drawer = new window._embellisher.CustomizationDrawer()

    const embellisher = new window._embellisher.Embellisher(
      drawer,
      document.getElementById('CustomizationDrawer'),
      '#bny-previewer',
      '#bny-customizations'
    )

    // const finalSaleMgr = new window._embellisher.FinalSaleManager(embellisher)

    // finalSaleMgr.register()
    embellisher.init()

    document.addEventListener('drawerPreOpen.CustomizationDrawer', () => {
      embellisher.render(
        window._embellisher.customizations,
        $('#CustomizationDrawer').data('form-id')
      )
    });
  });
}());
